{
  "shared": {
    "filters": {
      "search": "Zoeken…",
      "freight_method": "Vervoersmethode",
      "status": "Status",
      "organization_one": "Organisatie",
      "organization_other": "Organisaties",
      "country_one": "Land",
      "country_other": "Landen",
      "watched_by": "Gevolgd door",
      "sort": "Sorteren",
      "cta_reset_filters": "Filters resetten",
      "anyone": "Iedereen",
      "no_one": "Niemand",
      "newest_first": "Nieuwste eerst",
      "oldest_first": "Oudste eerst",
      "company_name_a_to_z": "Bedrijfsnaam (A-Z)",
      "company_name_z_to_a": "Bedrijfsnaam (Z-A)",
      "import_export": "Import/Export",
      "validity": "Validiteit",
      "exceptions": "Uitzonderingen",
      "activity": "Activiteit",
      "departure": "Vertrek",
      "arrival": "Aankomst",
      "pickup": "Ophalen",
      "delivery": "Aflevering"
    },
    "order_status": {
      "sent": "Verzonden",
      "received": "Ontvangen",
      "in_progress": "In behandeling",
      "completed": "Voltooid",
      "canceled": "Geannuleerd"
    },
    "cta_create_booking": "Boeking plaatsen",
    "cta_request_quote": "Offerte aanvragen",
    "cta_view_spot_rate": "Bekijk offerte",
    "cta_view_shipment": "Bekijk zending",
    "cta_view_booking": "Bekijk boeking",
    "cta_view_request": "Bekijk aanvraag",
    "cta_view_all": "Alles weergeven",
    "cta_view": "Bekijk",
    "cta_edit": "Bewerken",
    "cta_delete": "Verwijderen",
    "cta_remove": "Verwijderen",
    "cta_save": "Opslaan",
    "cta_cancel": "Annuleren",
    "cta_confirm": "Bevestigen",
    "cta_close": "Sluiten",
    "cta_submit": "Verzenden",
    "cta_continue": "Doorgaan",
    "cta_next": "Volgende",
    "cta_back": "Terug",
    "cta_send": "Versturen",
    "cta_reset": "Resetten",
    "txt_dashboard": "Dashboard",
    "txt_quotes": "Aanvragen & Offertes",
    "txt_quote_request_one": "Offerteaanvraag",
    "txt_quote_request_other": "Offerteaanvragen",
    "txt_spot_rate_one": "Offerte",
    "txt_spot_rate_other": "Offertes",
    "txt_contract_one": "Contract",
    "txt_contract_other": "Contracten",
    "txt_booking_one": "Boeking",
    "txt_booking_other": "Boekingen",
    "txt_shipment_one": "Zending",
    "txt_shipment_other": "Zendingen",
    "txt_invoice_one": "Factuur",
    "txt_invoice_other": "Facturen",
    "txt_address_book": "Adresboek",
    "txt_reporting": "Rapportage",
    "txt_organization_one": "Organisatie",
    "txt_organization_other": "Organisaties",
    "txt_what's_new?": "Wat is er nieuw?",
    "txt_calendar": "Kalender",
    "txt_general": "Algemeen",
    "txt_incoterm": "Incoterm",
    "txt_incoterm_place": "Incoterm-locatie",
    "txt_bill_of_lading": "Bill of Lading",
    "alert_confirm_bill_of_lading": "Ik bevestig dat de verstrekte Bill of Lading correct is en van toepassing is op alle lading in deze boeking.",
    "txt_routing": "Routing",
    "txt_service": "Service",
    "txt_container": "Container",
    "txt_containers": "Containers",
    "txt_quantity": "Hoeveelheid",
    "txt_type": "Type",
    "txt_cargo_details": "Vrachtgegevens",
    "txt_weight": "Gewicht",
    "txt_packages": "Pakketten",
    "txt_weight_per_piece": "Gewicht per stuk",
    "txt_total_weight": "Totaalgewicht",
    "txt_length_per_piece": "Lengte per stuk",
    "txt_width_per_piece": "Breedte per stuk",
    "txt_height_per_piece": "Hoogte per stuk",
    "txt_volume_per_piece": "Volume per stuk",
    "txt_total_volume": "Totaal volume",
    "txt_dimensions_per_piece": "Afmetingen per stuk",
    "txt_dangerous_goods": "Gevaarlijke goederen",
    "txt_total": "totaal",
    "txt_product_ready_date": "Productgereedheidsdatum",
    "txt_anticipated_delivery_date": "Verwachte leverdatum",
    "txt_goods_description": "Goederenomschrijving",
    "txt_attachments": "Bijlagen",
    "txt_required": "Verplicht",
    "txt_invalid_number": "Ongeldig nummer",
    "txt_value_must_be_greater_than_zero": "{{type}} moet groter zijn dan nul",
    "txt_invalid_date_format": "Ongeldig datumformaat",
    "txt_air_freight": "Luchtvracht",
    "txt_ocean_freight": "Zeevracht",
    "txt_expired": "Verlopen",
    "txt_rejected": "Afgewezen",
    "txt_booked": "Geboekt",
    "txt_valid": "Geldig",
    "txt_air": "Lucht",
    "txt_sea": "Zee",
    "txt_yes": "Ja",
    "txt_your_reference": "Uw referentie",
    "txt_your_references": "Uw referenties",
    "txt_purchase_references": "Inkoopreferenties",
    "txt_direct": "Direct",
    "txt_indirect": "Indirect",
    "txt_rotra_reference": "Rotra-referentie",
    "txt_cargo": "Vracht",
    "txt_costs": "Kosten",
    "txt_new": "NIEUW!",
    "txt_refreshing": "Bezig met laden...",
    "txt_all_in_price": "All-in prijs",
    "txt_pagination_text": "Toont {{startItemsCount}} - {{endItemsCount}} van {{totalItems}} {{listType}}",
    "txt_total_maximum_container_quantity": "Maximum aantal containers is {{totalMaximumQuantity}}",
    "txt_transport_method": "Vervoersmethode",
    "txt_invalid_phone_number": "Vul een geldig telefoonnummer in bestaande uit cijfers, spaties of standaard symbolen.",
    "txt_invalid_container_number": "Ongeldig containernummer (ISO 6346)",
    "txt_invalid_hs_code": "HS-code mag alleen 6 tot 18 cijfers bevatten",
    "txt_all_container_types": "Alle containertypes",
    "txt_per_kg_per_container": "per KG per container",
    "txt_select_option_you_would_like_to_book": "Selecteer de optie die u wilt boeken",
    "txt_airline": "Luchtvaartmaatschappij",
    "field_is_required": "Dit veld is verplicht",
    "field_max_length_128": "Dit veld mag maximaal 128 tekens bevatten",
    "field_max_length_400": "Dit veld mag maximaal 400 tekens bevatten",
    "field_min_length_5": "Dit veld moet minimaal {{min}} tekens bevatten.",
    "field_max_length_512": "Dit veld mag maximaal {{max}} tekens bevatten.",
    "field_min_value": "De minimumwaarde is {{min}}",
    "field_must_be_positive": "De waarde moet positief zijn",
    "array_min_items": "Voeg minimaal {{min}} item(s) toe.",
    "array_max_items": "Je kunt maximaal {{max}} item(s) toevoegen.",
    "email_is_invalid": "Vul een geldig e-mailadres in",
    "date_min": "De datum mag niet vóór {{date}} liggen.",
    "date_max": "De datum mag niet na {{date}} liggen.",
    "password_invalid_format": "Het wachtwoord moet minstens 8 tekens bevatten, waaronder één hoofdletter, één cijfer en één speciaal teken (!@#$%^&*).",
    "txt_country_is_invalid": "Land is ongeldig, selecteer een land uit de lijst",
    "txt_postal_code_invalid": "Postcode is ongeldig",
    "txt_invalid_email_address": "E-mailadres is ongeldig",
    "txt_invalid_date": "Ongeldig datumformaat, gebruik dd-mm-yyyy.",
    "txt_loading": "Laden...",
    "txt_today": "Vandaag",
    "txt_tomorrow": "Morgen",
    "txt_you": "Jij",
    "sales": {
      "txt_per_container": "per container",
      "txt_warning_inland_transport_unavailable": "Let op: de kosten voor voor- en natransport zijn niet berekend, omdat deze niet beschikbaar zijn voor de geselecteerde postcode en het geselecteerde land ({{postcode}}, {{country_code}}).",
      "txt_inland_transport_could_not_be_calculated": "Voor- en natransport kon niet worden berekend",
      "txt_charges_not_calculated_not_available": "Let op: de kosten voor voor- en natransport zijn niet berekend, omdat deze niet beschikbaar zijn voor de geselecteerde plaats",
      "txt_all_in_price_calculation_does_not_have_charges": "Let op: de all-in prijsberekening bevat geen kosten voor voor- en natransport, omdat er geen kosten beschikbaar zijn voor het opgegeven gewicht.",
      "txt_origin": "Herkomst",
      "txt_destination": "Bestemming",
      "txt_freight": "Vracht",
      "txt_freight_surcharges": "Vrachttoeslagen",
      "txt_precarriage_charges": "Voortransportkosten",
      "txt_oncarriage_charges": "Natransportkosten",
      "txt_inland_transport": "Voor- en natransport",
      "txt_discharge_terminal_surcharges": "Uitslagterminalkosten (niet inbegrepen in de totaalprijs)",
      "txt_conditional_charges": "Voorwaardelijke kosten",
      "txt_charge": "Kosten",
      "txt_description": "Beschrijving",
      "txt_amount": "Bedrag",
      "txt_subtotal": "Subtotaal",
      "txt_cargo_charges": "Vrachtkosten",
      "txt_uncategorized": "Niet gecategoriseerd",
      "txt_general_charges": "Algemene kosten",
      "txt_charges_option": "Kosten optie",
      "txt_chargeable_weight": "Belastbaar gewicht",
      "txt_actual_weight": "Daadwerkelijk gewicht",
      "lbl_days": "DAGEN",
      "lbl_container": "CONTAINER",
      "lbl_unknown_unit": "onbekende eenheid",
      "txt_base": "(Basis)",
      "txt_minimum_price": "(Minimumprijs)",
      "txt_lumpsum_based_on_interval": "Forfaitair bedrag op basis van interval",
      "txt_interval_charge": "Intervaltoeslag"
    },
    "languages": {
      "txt_language_en": "Engels",
      "txt_language_nl": "Nederlands",
      "txt_language_pt": "Portugees",
      "txt_language_es": "Spaans",
      "txt_language_fr": "Frans",
      "txt_language_de": "Duits",
      "txt_language_it": "Italiaans"
    },
    "messages": {
      "txt_translation_disclaimer": "We gebruiken machinetranslaties, daarom kan de vertaling onnauwkeurig zijn",
      "txt_translated_from": "Vertaald uit {{language}}",
      "txt_show_original": "Toon origineel",
      "txt_show_translation": "Toon vertaling",
      "txt_translation_not_available": "Vertaling niet beschikbaar"
    },
    "notifications": {
      "txt_settings_updated_successfully": "{{type}} instellingen succesvol bijgewerkt",
      "txt_settings_updated_failed": "{{type}} instellingen bijwerken mislukt"
    }
  },
  "date_utils": {
    "txt_today_at": "Vandaag om",
    "txt_tomorrow": "Morgen",
    "txt_yesterday": "Gisteren",
    "txt_last": "Afgelopen"
  },
  "dashboard": {
    "title_dashboard": "Dashboard",
    "lbl_good_morning": "Goedemorgen",
    "lbl_good_afternoon": "Goedemiddag",
    "lbl_good_evening": "Goedenavond",
    "filter": "Filter",
    "calendar": {
      "title_calendar": "Kalender",
      "lbl_more": "meer",
      "txt_no_activities": "Je hebt geen geplande activiteiten",
      "lbl_arrival": "Aankomst",
      "lbl_departure": "Vertrek",
      "lbl_cargo_pickup": "Lading ophalen",
      "lbl_cargo_delivery": "Lading bezorgen"
    },
    "base_widget": {
      "txt_rearrange_widget": "Versleep om de widget te herschikken<br />naar een andere plek"
    },
    "exceptions": {
      "title_exceptions": "Uitzonderingen",
      "txt_no_exceptions": "Alles is in orde! <br /> Geen uitzonderingen in je zendingen gevonden"
    },
    "watched": {
      "title_watched_shipments": "Gevolgde zendingen",
      "txt_no_watched_shipments": "Je volgt momenteel geen shipments",
      "txt_watch_shipment": "Druk op het <icon /> bovenaan de zendingspagina om de zending te volgen."
    },
    "spot_rates": {
      "lbl_spot_rates": "Offertes",
      "txt_no_spot_rates_available": "Geen Offertes beschikbaar",
      "title_book": "Boek",
      "txt_starting_from": "Beginnend vanaf",
      "txt_all_in_price": "All-in prijs",
      "txt_more_options": "+ {{count}} meer opties",
      "txt_expires_in_one": "Verloopt in {{count}} dag",
      "txt_expires_in_other": "Verloopt in {{count}} dagen",
      "txt_expires_today": "Verloopt vandaag",
      "txt_quotes": "offertes"
    },
    "client_popover": {
      "lbl_organization": "Organisaties",
      "txt_account_number": "Account nummer",
      "alert_info_to_contact_myrotra": "Gebruik <strong>altijd</strong> het account nummer {{clientId}} van je organisatie of de Rotra referentie wanneer je Rotra contacteert.",
      "lbl_address": "Adres",
      "lbl_vat_number": "BTW nummer",
      "cta_view_organization": "Organisatie weergeven"
    },
    "shipment_routing": {
      "txt_new_eta_later": "Nieuwe ETA is minstens 24 uur later dan initieel gepland.",
      "txt_new_eta_earlier": "Nieuwe ETA is minstens 24 uur eerder dan gepland.",
      "txt_demurrage_detention_overdue": "Er zijn geen vrije demurage/detention dagen over voor minimaal één of meerdere containers.",
      "txt_demurrage_detention_one_day_left": "Er is nog maar één vrije dag Demurrage/Detention voor minstens één of meerdere containers.",
      "txt_routing_will_be_available": "Route zal binnenkort beschikbaar zijn",
      "txt_days": "({{daysLabel}} dagen)"
    },
    "shipments_map": {
      "txt_track_and_trace_data_not_available": "Track & Trace data is niet beschikbaar voor deze",
      "txt_your_reference": "Jouw referentie",
      "txt_rotra_reference": "Rotra referentie",
      "txt_current_location_estimation": "Huidige locatie is een verwachting op basis van ons schema. Track & Trace data is niet bevestigd voor deze shipment.",
      "txt_new_eta_later_than_planned": "Nieuwe ETA is minstens 24 uur later dan gepland",
      "txt_vessel": "boot",
      "txt_flight": "vlucht",
      "txt_unknown": "Onbekend"
    },
    "widget": {
      "txt_success": "De volgorde van je widgets is bijgewerkt",
      "txt_error": "Er is iets misgegaan bij het bijwerken van je widgets, probeer het opnieuw"
    }
  },
  "global_search": {
    "ph_search": "Zoeken...",
    "txt_no_shipment_found": "We konden die zending niet vinden.",
    "txt_hint_shipment_search": "Zoek zendingen op basis van referentie, container nummer of vrachtbrieven..",
    "txt_no_spot_rate_found": "We konden die offerte niet vinden.",
    "txt_hint_spot_rate_search": "Zoek offertes op basis van referentie nummer..",
    "txt_or_simply": "of simpelweg",
    "txt_no_booking_found": "We konden die boeking niet vinden.",
    "txt_hint_booking_search": "Zoek boekingen op basis van referentie nummer..",
    "txt_no_address_found": "We konden dat adres niet vinden.",
    "txt_hint_address_search": "Zoek adressen op basis van bedrijfsnaam..",
    "txt_or_quickly": "of ga direct",
    "txt_we_couldnt_find_that": "We konden dat niet vinden, probeer je zoekopdracht te veranderen..",
    "txt_from": "Vanaf",
    "txt_and_delayed": "en vertraagd",
    "txt_booked_times": "{{count}} keer geboekt",
    "txt_no_contacts_found": "geen contacten gevonden",
    "txt_something_went_wrong": "Er is iets misgegaan",
    "cta_check_out_now": "Check het nu",
    "valid_organization_button": "Deze functionaliteit is niet toegankelijk omdat je organisatie is vervallen. Neem contact op met je account manager of met ons Customer Succes team voor verdere hulp.",
    "modal": {
      "ph_search_question": "Waar ben je naar op zoek?",
      "cta_navigation": "Navigatie",
      "cta_quotes": "Offertes",
      "cta_contracts": "Contracten",
      "cta_bookings": "Boekingen",
      "cta_shipments": "Zendingen",
      "cta_quick_actions": "Snelle Acties",
      "cta_get_help": "Vraag om hulp"
    }
  },
  "app_layout": {
    "txt_english": "English",
    "txt_dutch": "Nederlands"
  },
  "rating_preview": {
    "cta_tooltip_with_feedback": "Klik hier om feedback weer te geven",
    "cta_tooltip_without_feedback": "Klik hier om feedback achter te laten",
    "txt_tooltip_rating_is_not_available": "De beoordeling van de zending is op dit moment nog niet beschikbaar.",
    "dialog": {
      "dismissed": {
        "txt_title": "Beoordeel deze zending",
        "alert_rating_this_shipment": "Het beoordelen van deze zending helpt ons onze service te verbeteren. Neem alsjeblieft een moment om deze zending te beoordelen."
      },
      "rating_preview": {
        "txt_title": "Je beoordeling van deze zending",
        "txt_user_indicator": "<strong>{{user}}</strong>, liet deze beoordeling achter op {{date}}",
        "lbl_no_feedback": "Geen feedback gegeven",
        "lbl_feedback": "Feedback:",
        "txt_you": "Jij"
      }
    }
  },
  "rating_form": {
    "txt_submit_success": "Bedankt voor je feedback!",
    "txt_submit_error": "Er is een fout opgetreden bij het verzenden van je feedback. Probeer het later opnieuw.",
    "txt_description": "Jouw feedback helpt ons onze service te verbeteren. Neem alsjeblieft een moment om deze zending te beoordelen.",
    "txt_free_input_placeholder": "Wat zou ons kunnen helpen om te verbeteren?",
    "cta_rate_now": "Beoordeel nu",
    "txt_what_do_you_think": "Wat denk jij?",
    "txt_feedback_helps_improve": "Jouw feedback helpt ons onze service te verbeteren. Neem alsjeblieft een moment om deze zending te beoordelen."
  },
  "reporting": {
    "txt_title": "Rapportage",
    "txt_total_dem_det_days": "Totaal Dem/Det dagen",
    "txt_origin_destination": "Herkomst / Bestemming",
    "txt_origin_destination_cities": "Herkomst- / Bestemmingssteden",
    "txt_total_teu_over_time": "Totaal TEU in de tijd",
    "txt_total_teu": "Totaal TEU",
    "txt_total": "Totaal:",
    "txt_total_costs": "Totale kosten",
    "txt_main_costs_types": "Belangrijkste kostentypes",
    "txt_inland_costs": "Binnenlandskosten",
    "txt_other_costs": "Overige kosten",
    "txt_origin_costs": "Oorsprongskosten",
    "txt_destination_costs": "Bestemmingskosten",
    "txt_freight_costs": "Vrachtkosten",
    "txt_origin_destination_costs": "Oorsprong / Bestemming kosten",
    "txt_fcl_costs": "FCL-kosten",
    "txt_lcl_costs": "LCL-kosten",
    "txt_air_costs": "Luchtvrachtkosten",
    "txt_truck": "Vrachtwagen",
    "txt_train": "Trein",
    "txt_barge": "Binnenvaartschip",
    "tabs": {
      "txt_general": "Algemeen",
      "txt_air": "Lucht",
      "txt_sea": "Zee",
      "txt_costs": "Kosten",
      "txt_custom_report": "Aangepast Rapport",
      "txt_emission": "Emissie"
    },
    "no_data": {
      "txt_title": "Geen Gegevens Beschikbaar",
      "txt_subtitle": "Er zijn geen gegevens die voldoen aan uw huidige filtercriteria. Probeer uw filters of datumbereik aan te passen om verzendgegevens te bekijken.",
      "cta_clear_filters": "Filters leegmaken"
    },
    "top_bar": {
      "filters": {
        "txt_date_range": "Datumbereik",
        "date_modal": {
          "txt_title": "Selecteer Datumbereik",
          "txt_description": "Kies de begin- en einddatum om de gegevens te filteren.",
          "txt_start_date": "Begindatum",
          "txt_end_date": "Einddatum",
          "cta_this_month": "Deze Maand",
          "cta_last_month": "Vorige Maand",
          "cta_ytd": "YTD",
          "cta_last_year": "Vorig Jaar"
        },
        "txt_organizations": "Organisaties",
        "txt_modality": "Modaliteit",
        "txt_direction": "Richting",
        "txt_carrier": "Vervoerder",
        "txt_origin": "Herkomst",
        "txt_destination": "Bestemming",
        "txt_container_load": "Containerlading",
        "txt_container_type": "Containertype",
        "cta_reset_filters": "Filters Herstellen",
        "txt_is_direct": "Directe vlucht"
      },
      "download_modal": {
        "txt_title": "Download Rapport",
        "txt_description": "U staat op het punt dit rapport te downloaden. Kies hieronder welk bestandstype u wilt downloaden:",
        "txt_file": "Bestand",
        "txt_confirmation": "Wilt u doorgaan met downloaden?",
        "cta_cancel": "annuleren"
      }
    },
    "graphs": {
      "cta_expand": "Uitvouwen",
      "cta_minimize": "Minimaliseren",
      "txt_day": "Dag",
      "txt_week": "Week",
      "txt_month": "Maand",
      "txt_origin": "Herkomst",
      "txt_destination": "Bestemming",
      "txt_shipments": "Verzendingen",
      "txt_min": "Min",
      "txt_q1": "Q1",
      "txt_median": "Mediaan",
      "txt_q3": "Q3",
      "txt_max": "Max",
      "txt_deviation_iqr": "Afwijking (IQR)",
      "txt_unit_day": "d",
      "txt_unit_hour": "u"
    },
    "downloading": {
      "title": "Download Rapport",
      "description": "U staat op het punt dit rapport te downloaden. Kies hieronder welk bestandstype u wilt downloaden:",
      "file": "Bestand",
      "note": "Opmerking: Eventuele filters die op het rapport zijn toegepast, worden ook toegepast op het gedownloade bestand.",
      "confirmation": "Wilt u doorgaan met downloaden?",
      "cancel": "Annuleren"
    },
    "general": {
      "cards": {
        "txt_total_shipments": "Totale Verzendingen",
        "txt_total_costs": "Totale Kosten",
        "txt_total_volume": "Totale Volume",
        "txt_total_teu": "Totale TEU",
        "txt_total_weight": "Totaalgewicht",
        "txt_total_volume_weight": "Totaal volumegewicht",
        "txt_total_chargeable_weight": "Totale Belastbare Gewicht",
        "txt_total_co2e": "Totale CO2e",
        "txt_average_co2e": "Gemiddelde CO2e",
        "txt_total_freight_emission": "Totale Vrachtuitstoot",
        "txt_total_inland_emission": "Totale Binnenlandse Uitstoot",
        "txt_co2e_trend": "Uw CO2e trend",
        "txt_co2e_trend_description": "Vergeleken met de laatste {{period}}",
        "txt_average_weight_per_shipment": "Gemiddeld gewicht per Zending",
        "txt_freight_costs": "Vrachtkosten",
        "txt_inland_costs": "Binnenlandskosten",
        "txt_local_costs": "Lokalekosten",
        "txt_average_cost_per_shipment": "Gem. kosten per Zending",
        "txt_customs_duties_costs": "Douanekosten",
        "txt_last": "Laatste",
        "txt_day": "dag",
        "txt_week": "week",
        "txt_month": "maand"
      },
      "graphs": {
        "txt_shipments_over_time": "Aantal verzendingen over tijd",
        "txt_costs": "Kosten over tijd (€)",
        "txt_volume_over_time": "Volume over tijd (m³)",
        "txt_chargeable_weight_over_time": "Belastbaar gewicht over tijd (KG)",
        "txt_weight_over_time": "Gewicht over tijd (KG)",
        "txt_count": "Aantal",
        "txt_chargeable_weight": "Belastbaar gewicht",
        "txt_accumulated_count": "Cumulatieve Aantal",
        "txt_accumulated_weight": "Cumulatieve gewicht",
        "txt_accumulated_dem_count": "Cumulatieve Dem Aantal",
        "txt_accumulated_det_count": "Cumulatieve Det Aantal",
        "txt_accumulated_value": "Cumulatieve Waarde",
        "txt_accumulated_inland_costs": "Gecumuleerde binnenlandskosten",
        "txt_accumulated_other_costs": "Geaccumuleerde overige kosten",
        "txt_accumulated_customs_duties_costs": "Gecumuleerde douanekosten",
        "txt_volume": "Volume",
        "txt_total_emission_over_time": "Totale uitstoot over tijd",
        "txt_total_emission_over_time_info": "WTT (Well to Tank): uitstoot bij het produceren en transporteren van de brandstof vóór gebruik.\nTTW (Tank to Wheel): uitstoot die vrijkomt bij het verbranden van de brandstof tijdens het transport.\nCumulatieve waarde: het lopende totaal van WTT + TTW over de gekozen periode.",
        "txt_inland_emission_over_time": "Binnenlandse uitstoot over tijd",
        "txt_inland_emission_over_time_info": "Uitstoot van binnenlandse transportmodaliteiten (vrachtwagen, binnenvaartschip en trein).\nCumulatieve waarde: het lopende totaal van binnenlandse uitstoot over de gekozen periode.",
        "txt_freight_emission_over_time": "Goederenvervoer-uitstoot over tijd",
        "txt_freight_emission_over_time_info": "Uitstoot van de belangrijkste goederenvervoermodaliteiten (lucht en zee).\nCumulatieve waarde: het lopende totaal van goederenvervoer-uitstoot over de gekozen periode."
      }
    },
    "otp": {
      "cards": {
        "txt_on_time_performance": "On-time performance (%)",
        "txt_average_deviation_time": "Gemiddelde afwijkingstijd",
        "txt_average_transit_time": "Gemiddelde transittijd"
      },
      "graphs": {
        "txt_performance_per_carrier": "Performance per vervoerder",
        "txt_performance_per_airline": "Performance per luchtvaartmaatschappij",
        "txt_deviation_per_carrier": "Afwijking per vervoerder",
        "txt_deviation_per_airline": "Afwijking per luchtvaartmaatschappij",
        "txt_transit_time_per_routing": "Gemiddelde transittijd per routing",
        "txt_axis_otp_percent": "On-time performance (%)",
        "txt_axis_carrier": "Vervoerder",
        "txt_axis_airline": "Luchtvaartmaatschappij",
        "txt_deviation": "Afwijking",
        "txt_axis_routing": "Routing",
        "txt_axis_transit_hours": "Transittijd",
        "txt_otp_over_time": "On-time performance over tijd",
        "txt_axis_period": "Periode",
        "txt_overall": "Algehele performance",
        "txt_overall_count": "Totaal aantal",
        "txt_air_shipments": "Air zendingen",
        "txt_sea_shipments": "Sea zendingen"
      },
      "configurations": {
        "txt_title": "On-time performance configuraties",
        "txt_air_threshold": "Air drempelwaarde",
        "txt_sea_threshold": "Sea drempelwaarde",
        "txt_hour": "uur",
        "txt_hours": "uur",
        "txt_day": "dag",
        "txt_days": "dagen"
      }
    },
    "txt_demurrage_detention_costs": "Demurrage/Detentie kosten"
  },
  "custom_reporting": {
    "txt_general": "Algemeen",
    "txt_air": "Lucht",
    "txt_sea": "Zee",
    "txt_costs": "Kosten",
    "txt_emission": "Emissie",
    "lbl_newest_first": "Nieuwste eerst",
    "lbl_oldest_first": "Oudste eerst",
    "lbl_weekly": "Wekelijks",
    "lbl_monthly": "Maandelijks",
    "lbl_yearly": "Jaarlijks",
    "txt_loading": "Persoonlijke rapporten laden...",
    "txt_reports_count": "Je hebt {{count}} persoonlijke rapporten",
    "alert_created_success": "Persoonlijk rapport succesvol aangemaakt",
    "alert_deleted_success": "Persoonlijk rapport succesvol verwijderd",
    "cta_create_report": "Rapport aanmaken",
    "cta_download": "Downloaden",
    "txt_name": "Naam",
    "txt_organization": "Organisatie",
    "txt_category": "Categorie",
    "txt_creation_date": "Aanmaakdatum",
    "txt_generation_interval": "Generatie-interval",
    "txt_recurring_report": "Terugkerend rapport",
    "txt_no_results_title": "We kunnen dat persoonlijke rapport niet vinden",
    "txt_no_results_desc": "Probeer je zoekterm te wijzigen of controleer je filters.",
    "txt_empty_title": "Je hebt nog geen persoonlijke rapporten",
    "txt_empty_desc": "Begin nu met het maken van je eerste persoonlijke rapport",
    "lbl_category": "Categorie",
    "lbl_edit_report": "Persoonlijk rapport bewerken",
    "lbl_create_report_title": "Rapport aanmaken",
    "txt_step_general_info": "Algemene informatie",
    "txt_step_select_columns": "Kolommen selecteren",
    "cta_generate_report": "Rapport genereren",
    "cta_generating": "Bezig met genereren...",
    "txt_step1_intro_title": "Je staat op het punt je eigen persoonlijke rapport te genereren",
    "txt_step1_intro_desc": "Vul hieronder de gegevens in",
    "txt_report_name_placeholder": "Rapportnaam...",
    "txt_generation_mode_question": "Wil je dit rapport één keer genereren of er een terugkerend rapport van maken?",
    "lbl_generate_once": "Eenmalig genereren",
    "lbl_recurring_generation": "Terugkerende generatie",
    "lbl_generation_interval": "Generatie-interval",
    "lbl_period_week": "week",
    "lbl_period_month": "maand",
    "lbl_period_year": "jaar",
    "txt_recurring_start_explanation": "Het eerste rapport wordt gegenereerd aan het begin van de huidige {{period}}",
    "lbl_from": "Van",
    "lbl_to": "Tot",
    "err_date_range": "Van moet vóór Tot liggen",
    "lbl_configure_columns": "Rapportkolommen configureren",
    "txt_drag_instruction": "Sleep items van links naar rechts om ze in je rapport op te nemen.",
    "lbl_available_columns": "Beschikbare kolommen",
    "cta_add_all": "Alles toevoegen",
    "cta_remove_all": "Alles verwijderen",
    "lbl_columns_to_include": "Op te nemen kolommen",
    "txt_drag_placeholder": "Sleep kolommen hierheen om ze op te nemen",
    "err_no_columns_selected": "* Het is niet mogelijk een persoonlijk rapport aan te maken of bij te werken zonder kolommen te selecteren die je wilt downloaden.",
    "lbl_edit_report_title": "Rapport bewerken: {{name}}",
    "cta_update": "Bijwerken",
    "cta_updating": "Bezig met bijwerken...",
    "lbl_delete_report_title": "{{name}} verwijderen",
    "txt_delete_report_confirm": "Weet u zeker dat u het rapport genaamd {{name}} wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    "col_lbl_purchase_reference": "Inkoopreferentie",
    "col_desc_purchase_reference": "De unieke referentiecode voor de inkooporder.",
    "col_lbl_custom_duties_costs": "Invoerrechten",
    "col_desc_custom_duties_costs": "Totale kosten met betrekking tot douaneheffingen en belastingen voor deze zending.",
    "col_lbl_shipment_no": "Zendingnummer",
    "col_desc_shipment_no": "De unieke identificatie van de zending.",
    "col_lbl_client_reference": "Klantreferentie",
    "col_desc_client_reference": "Het referentienummer dat door de klant is opgegeven.",
    "col_lbl_acc_no": "Accountnummer",
    "col_desc_acc_no": "Het accountnummer dat aan de zending is gekoppeld.",
    "col_lbl_modality": "Modaliteit",
    "col_desc_modality": "Het type transport (bijv. zee, lucht).",
    "col_lbl_direction": "Richting",
    "col_desc_direction": "Of de zending import of export is.",
    "col_lbl_service": "Service",
    "col_desc_service": "Het gebruikte serviceniveau (bijv. FCL, LCL).",
    "col_lbl_module": "Module",
    "col_desc_module": "De operationele module die voor deze zending wordt gebruikt.",
    "col_lbl_incoterm": "Incoterm",
    "col_desc_incoterm": "Internationale handelsvoorwaarden die verantwoordelijkheden vastleggen.",
    "col_lbl_is_direct": "Directe vlucht",
    "col_desc_is_direct": "Geeft aan of de zending een directe vlucht betreft.",
    "col_lbl_stops": "Stops",
    "col_desc_stops": "Aantal tussenstops voor luchtzendingen.",
    "col_lbl_book_period": "Boekingsperiode",
    "col_desc_book_period": "De periode waarin de boeking is gemaakt.",
    "col_lbl_logistic_spends": "Logistieke kosten",
    "col_desc_logistic_spends": "Totale logistieke uitgaven voor deze zending.",
    "col_lbl_teu": "TEU",
    "col_desc_teu": "Twenty-foot Equivalent Unit (containerinhoud).",
    "col_lbl_volume": "Volume",
    "col_desc_volume": "Het volume van de zending (CBM).",
    "col_lbl_volume_weight": "Volumegewicht",
    "col_desc_volume_weight": "De berekening van het volumetrische gewicht.",
    "col_lbl_weight": "Brutogewicht",
    "col_desc_weight": "Het totale brutogewicht van de zending.",
    "col_lbl_chargeable_weight": "Belastbaar gewicht",
    "col_desc_chargeable_weight": "Het gewicht dat wordt gebruikt voor de berekening van vrachtkosten.",
    "col_lbl_container_load": "Containerbelading",
    "col_desc_container_load": "Type belading (FCL/LCL).",
    "col_lbl_container_number": "Containernummer",
    "col_desc_container_number": "De unieke identificatie van de container.",
    "col_lbl_container_type": "Containertype",
    "col_desc_container_type": "Type container (bijv. 20GP, 40HC).",
    "col_lbl_volume_teu": "Volume (TEU)",
    "col_desc_volume_teu": "Volume uitgedrukt in TEU.",
    "col_lbl_origin": "Oorsprong",
    "col_desc_origin": "De locatiecode of naam van oorsprong.",
    "col_lbl_origin_country": "Land van oorsprong",
    "col_desc_origin_country": "Het land waar de zending vandaan komt.",
    "col_lbl_destination": "Bestemming",
    "col_desc_destination": "De locatiecode of naam van bestemming.",
    "col_lbl_destination_country": "Land van bestemming",
    "col_desc_destination_country": "Het land waar de zending naartoe gaat.",
    "col_lbl_dem_days": "Demurragedagen",
    "col_desc_dem_days": "Aantal dagen waarvoor demurrage wordt berekend.",
    "col_lbl_det_days": "Detentiedagen",
    "col_desc_det_days": "Aantal dagen waarvoor detention wordt berekend.",
    "col_lbl_demdet_days": "Dem/Det-dagen",
    "col_desc_demdet_days": "Gecombineerde demurrage- en detentiondagen.",
    "col_lbl_dem_costs": "Demurragekosten",
    "col_desc_dem_costs": "Kosten voor demurrage.",
    "col_lbl_det_costs": "Detentionkosten",
    "col_desc_det_costs": "Kosten voor detention.",
    "col_lbl_demdet_costs": "Dem/Det-kosten",
    "col_desc_demdet_costs": "Gecombineerde demurrage- en detentionkosten.",
    "col_lbl_yoc_costs": "YOC-kosten",
    "col_desc_yoc_costs": "Yard Occupancy Charges.",
    "col_lbl_demdetadminfee_costs": "Administratiekosten",
    "col_desc_demdetadminfee_costs": "Administratieve kosten voor demurrage en detention.",
    "col_lbl_storage_costs": "Opslagkosten",
    "col_desc_storage_costs": "Kosten voor opslag in de terminal of haven.",
    "col_lbl_warehouserent_costs": "Magazijnhuur",
    "col_desc_warehouserent_costs": "Kosten voor magazijnhuur.",
    "col_lbl_freight_costs": "Vrachtkosten",
    "col_desc_freight_costs": "Hoofdvrachtkosten.",
    "col_lbl_origin_costs": "Kosten bij oorsprong",
    "col_desc_origin_costs": "Lokale kosten bij oorsprong.",
    "col_lbl_destination_costs": "Kosten bij bestemming",
    "col_desc_destination_costs": "Lokale kosten bij bestemming.",
    "col_lbl_road_costs": "Wegtransportkosten",
    "col_desc_road_costs": "Kosten voor wegtransport (voor- en natransport).",
    "col_lbl_internal_costs": "Interne kosten",
    "col_desc_internal_costs": "Interne verwerkingskosten.",
    "col_lbl_other_costs": "Overige kosten",
    "col_desc_other_costs": "Diverse kosten.",
    "col_lbl_total_costs": "Totale kosten",
    "col_desc_total_costs": "De som van alle kosten.",
    "col_lbl_inland_truck_wtt": "Truck WTT",
    "col_desc_inland_truck_wtt": "Truckemissies: Well-to-Tank.",
    "col_lbl_inland_truck_ttw": "Truck TTW",
    "col_desc_inland_truck_ttw": "Truckemissies: Tank-to-Wheel.",
    "col_lbl_inland_truck_total": "Truck totaal",
    "col_desc_inland_truck_total": "Totale truckemissies.",
    "col_lbl_inland_barge_wtt": "Barge WTT",
    "col_desc_inland_barge_wtt": "Barge-emissies: Well-to-Tank.",
    "col_lbl_inland_barge_ttw": "Barge TTW",
    "col_desc_inland_barge_ttw": "Barge-emissies: Tank-to-Wheel.",
    "col_lbl_inland_barge_total": "Barge totaal",
    "col_desc_inland_barge_total": "Totale barge-emissies.",
    "col_lbl_inland_train_wtt": "Trein WTT",
    "col_desc_inland_train_wtt": "Treinemissies: Well-to-Tank.",
    "col_lbl_inland_train_ttw": "Trein TTW",
    "col_desc_inland_train_ttw": "Treinemissies: Tank-to-Wheel.",
    "col_lbl_inland_train_total": "Trein totaal",
    "col_desc_inland_train_total": "Totale treinemissies.",
    "col_lbl_freight_sea_wtt": "Zeevracht WTT",
    "col_desc_freight_sea_wtt": "Zeevrachtemissies: Well-to-Tank.",
    "col_lbl_freight_sea_ttw": "Zeevracht TTW",
    "col_desc_freight_sea_ttw": "Zeevrachtemissies: Tank-to-Wheel.",
    "col_lbl_freight_sea_total": "Zeevracht totaal",
    "col_desc_freight_sea_total": "Totale zeevrachtemissies.",
    "col_lbl_freight_air_wtt": "Luchtvracht WTT",
    "col_desc_freight_air_wtt": "Luchtvrachtemissies: Well-to-Tank.",
    "col_lbl_freight_air_ttw": "Luchtvracht TTW",
    "col_desc_freight_air_ttw": "Luchtvrachtemissies: Tank-to-Wheel.",
    "col_lbl_freight_air_total": "Luchtvracht totaal",
    "col_desc_freight_air_total": "Totale luchtvrachtemissies.",
    "col_lbl_transit_hub_wtt": "Hub WTT",
    "col_desc_transit_hub_wtt": "Emissies van hubafhandeling: Well-to-Tank.",
    "col_lbl_transit_hub_ttw": "Hub TTW",
    "col_desc_transit_hub_ttw": "Emissies van hubafhandeling: Tank-to-Wheel.",
    "col_lbl_transit_hub_total": "Hub totaal",
    "col_desc_transit_hub_total": "Totale emissies van hubafhandeling.",
    "col_lbl_emission_wtt": "Totaal WTT",
    "col_desc_emission_wtt": "Totale emissies: Well-to-Tank.",
    "col_lbl_emission_ttw": "Totaal TTW",
    "col_desc_emission_ttw": "Totale emissies: Tank-to-Wheel.",
    "col_lbl_emission_total": "Totale emissie",
    "col_desc_emission_total": "Totale CO₂-voetafdruk van de zending.",
    "col_lbl_arrived_planned": "Geplande aankomsttijd",
    "col_desc_arrived_planned": "De geplande tijd waarop de zending zou aankomen.",
    "col_lbl_arrived_actual": "Werkelijke aankomsttijd",
    "col_desc_arrived_actual": "De werkelijke tijd waarop de zending is aangekomen.",
    "col_lbl_departed_planned": "Geplande vertrektijd",
    "col_desc_departed_planned": "De geplande tijd waarop de zending zou vertrekken.",
    "col_lbl_departed_actual": "Werkelijke vertrektijd",
    "col_desc_departed_actual": "De werkelijke tijd waarop de zending is vertrokken.",
    "col_lbl_arrival_diff": "Aankomstafwijking (u)",
    "col_desc_arrival_diff": "Verschil tussen geplande en werkelijke aankomsttijd, in uren.",
    "col_lbl_departed_diff": "Vertrekafwijking (u)",
    "col_desc_departed_diff": "Verschil tussen geplande en werkelijke vertrektijd, in uren.",
    "col_lbl_transit_time": "Transittijd (u)",
    "col_desc_transit_time": "Totale transittijd van de zending, in uren.",
    "col_lbl_shipper": "Verlader",
    "col_desc_shipper": "De verlader of de partij die verantwoordelijk is voor de verzending.",
    "col_lbl_consignee": "Ontvanger",
    "col_desc_consignee": "De ontvanger of de partij voor wie de zending bestemd is.",
    "col_lbl_carrier_name": "Naam vervoerder",
    "col_desc_carrier_name": "De naam van de vervoerder die verantwoordelijk is voor het transport van de zending.",
    "lbl_end_date": "Einddatum (Optioneel)"
  },
  "quote_requests": {
    "title_requests_and_quotes": "Aanvragen & Offertes",
    "title_quote_request": "Aanvragen & Offertes: Offerte Aanvragen",
    "txt_quote_requests": "offerte aanvragen",
    "txt_can't_find_quote_request": "We kunnen die offerteaanvraag niet vinden",
    "txt_no_quote_request": "Geen offerteaanvragen om weer te geven",
    "txt_change_search_phrase_or_filter": "Probeer je zoekopdracht te veranderen of check je filters.",
    "txt_quote_requests_displayed": "Je offerteaanvragen worden op deze pagina weergegeven wanneer je er een hebt aangevraagd.",
    "txt_request_first_quote": "Vraag je eerste offerte nu aan"
  },
  "sales_teaser": {
    "txt_created": "Aangemaakt:",
    "txt_last_updated": "Laatst geüpdatet:",
    "txt_unknown": "ombekend",
    "txt_all_in_price_disclaimer": "Aangegeven prijs is gebasseerd op je shipment specificaties, huidige valide toeslagen en de geschatte wisselkoers. Het uiteindelijke bedrag hangt af van tarief welke van toepassing is op het moment van transport.",
    "txt_price_is_excluding_additional_costs": "Deze prijs is exclusief bijkomende kosten zoals hieronder beschreven:",
    "txt_additional_costs_explanation": "Wanneer er bijkomende kosten plaatsvinden, kan de geoffereerde totaalprijs hoger uitvallen.",
    "lbl_option": "Optie",
    "txt_all_in_price": "All-in prijs",
    "txt_airline": "Luchtvaartmaatschappij",
    "txt_transit_time": "Transittijd",
    "txt_option_one": "optie",
    "txt_option_other": "opties",
    "txt_more": "meer",
    "txt_cargo_summary": "Samenvatting van de lading",
    "txt_amount_of_containers": "Aantal containers:",
    "txt_containers": "Containers:",
    "lbl_contact": "Contact:",
    "txt_your_reference": "Jouw referentie",
    "txt_rotra_reference": "Rotra referentie"
  },
  "sales_list": {
    "txt_spot_rates": "Vervoersmethode"
  },
  "new_quote_request_page": {
    "txt_creating_booking_without_rate_text": "Je bent een boeking aan het maken zonder tarief",
    "txt_new_quote_request": "Nieuwe Offerteaanvraag",
    "txt_new_quote_as_booking": "Nieuwe Boeking",
    "txt_resume_your_quote_request_text": "Wil je verder gaan met waar je gebleven was met het aanvragen van een offerte?",
    "cta_start_new": "Nee, begin opnieuw",
    "cta_yes_resume": "Ja, ga verder",
    "txt_thank_you_for_requesting_quote_text": "Bedankt voor het aanvragen van een offerte bij ons! U wordt op de hoogte gehouden van de verdere voortgang.",
    "txt_almost_there": "Bijna klaar ...",
    "txt_verify_information": "Verifieer de door u aangevraagde informatie hieronder. Druk op een van de 'bewerken' knoppen als u iets wilt corrigeren, of gebruik de ‘verzenden’ knop bovenaan of onderaan deze pagina om je verzoek in te dienen.",
    "cta_submitting": "Aanvragen ...",
    "txt_general": "Algemeen",
    "txt_purchase_references_helper": "Scheid meerdere referenties met een komma, spatie of enter",
    "txt_purchase_reference_already_added": "'{{reference}}' is al toegevoegd",
    "lbl_transport_method": "Vervoersmethode",
    "lbl_origin": "Herkomst",
    "product_ready_date": "Productgereedheidsdatum",
    "lbl_destination": "Bestemming",
    "txt_pickup_and_delivery": "Ophalen & levering",
    "lbl_pickup_shipper_address": "Ophalen / Verlader adres",
    "lbl_delivery_consignee_address": "Bezorging / Ontvanger adres",
    "alert_container_details_note": "Houd er rekening mee dat hoewel de container informatie optioneel zijn bij het indienen van een offerteaanvraag, een all-in prijs alleen kan worden aangeboden als de container informatie volledig zijn ingevuld. Als u een all-in prijs wilt ontvangen, vul dan het <1>type</1> in voor alle containers.",
    "cta_edit_containers": "Wijzig containers",
    "txt_yes": "Ja",
    "txt_no": "Nee",
    "alert_cargo_details_note": "Houd er rekening mee dat hoewel de vracht informatie optioneel zijn bij het indienen van een offerteaanvraag, een all-in prijs alleen kan worden aangeboden als de vracht informatie volledig zijn ingevuld. Als u een all-in prijs wilt ontvangen, vul dan het <1>gewicht, lengte, breedte en hoogte</1> in voor alle vracht.",
    "cta_edit_cargo_details": "Wijzig vracht informatie",
    "lbl_transit_time": "Transittijd",
    "lbl_additional_information": "Aanvullende informatie",
    "alert_change_organization": "Wanneer u de <1>organisatie</1> wijzigt, zullen je geselecteerde ophaal- en bezorgadressen, evenals de geüploade documenten, worden gereset.",
    "lbl_organization": "Organisatie",
    "txt_active_organizations": "Actieve organisaties",
    "txt_obsolete_organizations": "Obsolete organisaties",
    "txt_select_organization_to_add_address": "Selecteer een organisatie om en adres toe te kunnen voegen",
    "lbl_no_preference": "Geen voorkeur",
    "cta_delete_container": "Bestand container",
    "cta_add_another_container": "Container toevoegen",
    "lbl_per_piece": "per stuk",
    "cta_delete_package": "Bestand verpakking",
    "cta_add_another_package": "nog een pakket toevoegen",
    "ph_describe_contents_of_shipment": "Beschrijf de inhoud van je zending in het kort",
    "ph_please_enter_additional_information": "Hier aanvullende informatie invullen welke hulpvol kan zijn",
    "txt_invalid_file_name": "Alleen bestandsnamen zonder speciale tekens (Voorbeelden: example.pdf, example101.pdf en example_101.pdf) worden ondersteund door myRotra.<1/>Wijzig de bestandsnaam van uw upload om door te gaan met uw offerteaanvraag.",
    "txt_cargo_details": "Vrachtgegevens",
    "lbl_container_type": "Containertype",
    "cta_add_another": "Meer {{item}} toevoegen",
    "txt_pc": "st."
  },
  "contact_field": {
    "cta_edit_contact_information": "Contactgegevens bewerken",
    "cta_edit_address": "Adres bewerken",
    "cta_add_contact_information": "Contactgegevens toevoegen",
    "cta_add_address": "Adres toevoegen",
    "cta_delete_address": "Adres verwijderen",
    "txt_saving": "Bezig met opslaan",
    "update_address_select": "Adres bijwerken en selecteren",
    "txt_contact_information_incomplete": "Contactinformatie is onvolledig.",
    "txt_company": "Bedrijf",
    "txt_contact_information": "Contactinformatie",
    "txt_no_addresses_found": "Geen adressen gevonden",
    "ph_search_contacts": "Contacten zoeken",
    "txt_loading_address_book": "Adresboek laden",
    "txt_name": "Naam",
    "lbl_street_address_1": "Straatadres 1",
    "lbl_street_address_2": "Straatadres 2",
    "lbl_country": "Land",
    "lbl_postal_code": "Postcode",
    "lbl_city": "Stad",
    "cta_reset": "Resetten",
    "lbl_email": "Email",
    "lbl_phone": "Telefoon",
    "txt_company_edited": "bedrijf aangepast",
    "txt_from_addressbook": "uit adresboek",
    "txt_contact": "Contact",
    "cta_add_new": "Nieuwe toevoegen",
    "txt_contact_edited": "Contact aangepast",
    "txt_new_contact": "Nieuw contact",
    "txt_contact_person": "Contact persoon",
    "cta_update": "Werk de {{label}} bij",
    "cta_add": "Voeg een {{label}} toe",
    "cta_update_for_your_cargo": "Werk de {{label}} voor uw vracht bij",
    "cta_select_for_your_cargo": "Selecteer een {{label}} voor uw vracht"
  },
  "address_book": {
    "cta_update_address_select": "Adres bijwerken en selecteren",
    "cta_update_company_add_contact_select": "Bedrijf bijwerken, contact toevoegen en selecteren",
    "cta_update_company_select": "Bedrijf bijwerken en selecteren",
    "cta_update_contact_select": "Contact bijwerken en selecteren",
    "cta_add_contact_select": "Contact toevoegen en selecteren",
    "cta_save_address_select": "Adres opslaan en selecteren",
    "cta_select": "Selecteren",
    "txt_invalid_postal_code": "Postcode is niet geldig in het geselecteerde land"
  },
  "reusable_form_value": {
    "cta_save_value_for_later_reuse": "Bewaar waardes voor hergebruik",
    "cta_value_saved_for_later_reuse": "Waarde opgeslagen voor later hergebruik"
  },
  "attachments": {
    "txt_drop_files_here": "Sleep de bestanden hierheen ...",
    "txt_drag_and_drop": "Sleep wat bestanden hierheen, of klik om bestanden te selecteren",
    "txt_unsupported_file_name": "Alleen bestandsnamen met ASCII-afdrukbare tekens worden ondersteund door myRotra. Wijzig de bestandsnaam van je upload om door te gaan.",
    "txt_unsupported_type": "Het bestand dat je probeert te uploaden is van een niet-ondersteund bestandstype. Probeer je inhoud in een ander bestandstype te uploaden.",
    "txt_max_files": "Nog maximaal {{filesLeft}} bestanden, {{maxMbPerFile}}MB per bestand",
    "txt_only_file_without_special_characters": "Alleen bestandsnamen zonder speciale tekens worden ondersteund.",
    "txt_example_file_names": "<b>Bijvoorbeeld:</b> {{example1}}, {{example2}}, {{example3}}",
    "alert_maximum_amount_of_files_reached": "Maximaal aantal bestanden bereikt",
    "cta_delete": "Verwijder bestand",
    "cta_download": "Download"
  },
  "quote_request_detail_page": {
    "txt_rotra_reference": "Rotra referentie",
    "txt_quote_request_title": "Offerte aanvraag {{quoteRequestTitle}}",
    "txt_click_to_copy": "Klik hier om deze offerte aanvraag te kopiëren",
    "cta_copy_and_continue": "Kopieer en ga verder",
    "txt_copy_quote_request": "Offerte aanvraag kopiëren",
    "txt_copy_quote_request_confirmation": "U staat op het punt deze offerte aanvraag te kopiëren, om een nieuwe offerte aanvraag te creëren. Dit zal u doorwerwijzen naar de ‘Offerte aanvraag’ pagina. Wilt u verder gaan?",
    "txt_created": "Aangemaakt:",
    "txt_last_updated": "Laatst geüpdatet:",
    "alert_quote_request_thank_message": "Bedankt voor het aanvragen van een offerte bij ons! U wordt via deze pagina op de hoogte gehouden van de verdere voortgang.",
    "alert_your_requested_spot_rate_is_ready": "Je aangevraagde offerte is gereed:",
    "lbl_transport_method": "Vervoersmethode",
    "lbl_origin": "Herkomst",
    "lbl_destination": "Bestemming",
    "txt_pickup_and_delivery": "Ophalen & levering",
    "lbl_pickup_shipper_address": "Ophalen / Verlader adres",
    "lbl_delivery_consignee_address": "Bezorging / Ontvanger adres",
    "txt_cargo": "Vracht",
    "txt_pieces": "stuks",
    "txt_yes": "Ja",
    "txt_no": "Nee",
    "lbl_transit_time": "Transittijd",
    "lbl_additional_information": "Aanvullende informatie",
    "txt_chat_cannot_be_used_with_canceled_quote_request": "De berichten functionaliteit kan niet gebruikt worden bij geannuleerde offerte aanvragen",
    "txt_quote_request_processed_message_from_spot_rate": "Deze Offerte Aanvraag is succesvol verwerkt. U kunt ons nu berichten vanuit de offerte.",
    "txt_quote_request_processed_message_from_shipment": "Deze Offerte Aanvraag is succesvol verwerkt. U kunt ons nu berichten vanuit de zendingen.",
    "lbl_container_type": "Containertype",
    "txt_cargo_detail": "Vrachtgegevens",
    "alert_quote_request_canceled_message": "Deze Offerte Aanvraag is geannuleerd op {{dateTime}}.",
    "lbl_no_preference": "Geen voorkeur"
  },
  "messages_v2": {
    "txt_messages": "Berichten",
    "txt_no_messages": "Er zijn nog geen berichten.",
    "txt_messages_failed_to_load": "Laden van de berichten mislukt.",
    "txt_scroll_down_unnread_message": "Scroll naar beneden voor ongelezen bericht",
    "txt_scroll_down_unnread_messages": "Scroll naar beneden voor {{count}} ongelezen berichten",
    "txt_delviered": "Afgeleverd:",
    "txt_read_by": "Gelezen door:",
    "txt_scroll_up_unnread_message_one": "Scroll omhoog voor {{count}} ongelezen bericht",
    "txt_scroll_up_unnread_message_plural": "Scroll omhoog voor {{count}} ongelezen berichten",
    "lbl_only_show_unread": "Alleen ongelezen weergeven",
    "txt_marking_as_read": "Bezig met markeren als gelezen...",
    "cta_mark_as_read": "Markeren als gelezen",
    "cta_mark_amount_as_read": "Markeer {{count}} als gelezen",
    "cta_mark_all_as_read": "Alles als gelezen markeren"
  },
  "watch_entity_button": {
    "cta_click_to_watch_this": "Klik hier om deze {{entityType}} te volgen",
    "cta_stop_watching": "Stoppen met volgen",
    "cta_watch_now": "Volg nu",
    "txt_watching_this": "Volgen deze {{entityType}}",
    "txt_shipment": "zending",
    "txt_contract": "contract",
    "txt_booking": "boeking",
    "txt_quote": "offerte",
    "txt_quote_request": "offerteaanvraag"
  },
  "sales_item_detail": {
    "txt_loading": "Bezig met laden ...",
    "txt_item_not_found": "Item niet gevonden"
  },
  "watched_icon": {
    "txt_you_are_watching": "Je volgt dit",
    "txt_others_are_watching": "Anderen volgen dit"
  },
  "messages_icon": {
    "txt_unread_messages": "Je hebt {{count}} ongelezen berichten voor deze {{entity}}",
    "shipment": "zendingen",
    "quote_request": "offerte aanvraag",
    "spot_rate": "offerte"
  },
  "spot_rates": {
    "title_spot_rates": "Aanvragen & Offertes: Offertes",
    "txt_can't_find_spot_rate": "We kunnen die offerte niet vinden",
    "txt_no_spot_rates": "Geen offertes om weer te geven",
    "txt_change_search_phrase_or_filter": "Probeer je zoekopdracht te veranderen of check je filters.",
    "txt_spot_rates_displayed_on_this_page": "Je offertes worden op deze pagina weergegeven vanaf het moment dat je er een hebt aangevraagd.",
    "txt_spot_rates": "offertes"
  },
  "spot_rates_detail": {
    "cta_click_to_copy_spot_rate": "Klik hier om de offerte to kopiëren",
    "cta_copy_and_continue": "Kopieer en ga verder",
    "cta_copy_spot_rate": "Kopieer offerte",
    "txt_copy_confirmation": "Je staat op het punt deze offerte te kopiëren om zo een nieuwe offerteaanvraag aan te maken. Dit zal je doorverwijzen naar de ‘Offerte aanvragen’ pagina. Wil je hiermee verder gaan? ",
    "txt_created": "Aangemaakt:",
    "txt_last_updated": "Laatst geüpdatet:",
    "cta_view_new_spot_rate": "Nieuwe offerte weergeven",
    "txt_quote_rejected_alert": "{{user}} heeft deze offerte op {{dateTime}} afgewezen.<br/> Reden: {{reason}}",
    "txt_reason": "Reden",
    "txt_this_spot_rate_was_rejected": "Deze offerte was afgewezen op:",
    "txt_this_spot_rate_expired": "Deze offerte is verlopen op:",
    "txt_this_spot_rate_cannot_be_booked": "Deze offerte kan niet geboekt worden, omdat de organisatie waarmee je probeert te boeken verouderd is.",
    "txt_you_have_rejected_the_quotation": "You have rejected the quotation.",
    "alert_requested_booking": "Je hebt een boeking aangevraagd",
    "txt_booking_option_message": "voor optie {{option}} op {{date}}",
    "alert_no_booking_options": "Een onbekende fout heeft plaatsgevonden. Deze offerte kan momenteel niet geboekt worden. Probeer het later opnieuw.",
    "cta_book_now": "Boek nu",
    "cta_book": "Boek",
    "cta_download": "Download",
    "cta_view_spot_rate_pdf": "Offerte bekijken",
    "cta_view_pdf": "Bekijk",
    "txt_reject_spot_rate": "Wijs de offerte af",
    "txt_reject_spot_rate_message": "Wees er van bewust dat het afwijzen van een offerte betekent dat ook alle opties welke onderdeel van de offerte zijn afgewezen worden.",
    "txt_reject_spot_rate_message_2": "Wanneer je één optie wilt boeken en de anderen wilt afwijzen, kun je op de ‘boek’ knop drukken na het selecteren van de gewensd optie. Nadat de boeking geplaatst is zullen de andere opties als ‘afgewezen’ beschouwd worden.",
    "lbl_why_reject_spot_rate": "Waarom wijs je deze offerte af?",
    "txt_reject_message_too_long": "Je hebt de maximale tekstgrootte bereikt. Gelieve je reden korter te maken.",
    "book_from_spot_rate": "Boek vanuit offerte",
    "txt_select_option_you_would_like_to_book": "Selecteer de optie die je wilt boeken",
    "cta_continue_to_booking": "Ga verder naar boeking",
    "lbl_select_the_option_to_book": "Selecteer één van de opties hieronder om verder te gaan met boeken.",
    "txt_origin": "Herkomst",
    "txt_destination": "Bestemming",
    "txt_all_containers_supported": "Alle containers ondersteund",
    "txt_any_location": "Iedere locatie",
    "txt_transit_flight": "Transit vlucht",
    "txt_direct_flight": "Directe vlucht",
    "txt_via": "via ",
    "txt_transit_time": "Transit tijd",
    "txt_airline": "Luchtvaartmaatschappij",
    "txt_carrier": "Vervoerder",
    "txt_coloader": "Bijlader",
    "txt_supports_only_destination_and_road_charges": "Deze optie ondersteunt enkel bestemmings & wegtransport kosten op locatie.",
    "txt_only_inland_at_origin": "Enkel binnenlands vervoer bij de herkomst",
    "txt_only_inland_at_destination": "Enkel binnenlands vervoer bij de bestemming",
    "txt_price_available_in_next_steps": "Prijs beschikbaar in volgende stap",
    "txt_rejected_title": "De berichtenfunctie kan niet worden gebruikt met afgewezen Offertes",
    "txt_expired_adjusted_title": "De berichtenfunctie kan niet worden gebruikt met verlopen Offertes",
    "txt_has_shipment": "Deze Offerte is succesvol verwerkt. Je kunt ons nu een bericht sturen vanuit de Zending.",
    "txt_chargeable": "Kostenplichtig",
    "txt_actual": "Werkelijk",
    "txt_days": "dagen",
    "txt_error_multiple_total_prices": "Fout: meerdere totale prijzen gevonden",
    "txt_reject_quotation": "Offerte afwijzen",
    "txt_terms_and_conditions": "Algemene voorwaarden",
    "sea": {
      "txt_any_origin": "Elke herkomst",
      "txt_any_destination": "Elke bestemming",
      "txt_expected_terminal": "Verwachte terminal",
      "txt_load_terminal": "Laadterminal",
      "txt_all_in_price_explanation": "Aangegeven all-in bedrag is gebasseerd op de wisselkoers van vandaag (USD 🡪 EUR), definitieve factuur is gebasseerd op de wisselkoersen van schepen op het moment van transport en kan variëren.\n\nBrandstof toeslagen (wanneer aangegeven en inbegrepen) zijn variabel en worden berekent op moment van (weg)transport.",
      "txt_all_in_price_explanation_belgium": "Huidige all-in bedrag is gebasseerd op de USD naar EUR wissselkoers van vandaag. Definitieve factuur is gebasseerd op de wisselkoers op het moment van transport en kan afwijkend zijn.",
      "alert_all_in_price_info": "Niet mogelijk om all-in prijs voor deze offerte te calculeren, download de offerte door op de ‘download’ knop hieronder te drukken om alle kosten in te zien.",
      "lbl_valid_until": "Valide tot:",
      "txt_charges_breakdown": "Kostenverdeling:",
      "lbl_total_cargo_charges": "Totale vrachtkosten:",
      "cta_view_details": "Details weergeven",
      "lbl_total_general_charges": "Totale algemene kosten:",
      "txt_cargo_quantity": "Vracht",
      "lbl_contact": "Contact",
      "txt_quote": "Offerte"
    },
    "air": {
      "txt_any_location": "Elke",
      "txt_airline": "Luchtvaartmaatschappij:",
      "txt_routing": "Route:",
      "txt_any_origin": "Elke herkomst",
      "txt_any_destination": "Elke bestemming",
      "lbl_contact": "Contact",
      "txt_option": "Optie",
      "txt_all_in_price_description": "Aangegeven prijs is gebasseerd op je opgegeven transportspecificaties, huidige valide toeslagen en een geschatte wisselkoers. Het uiteindelijke bedrag hangt af van de wisselkoers op het moment van transport.",
      "lbl_valid_until": "Valide tot:",
      "lbl_airline": "Luchtvaartmaatschappij:",
      "lbl_routing": "Route:",
      "lbl_transit_time": "Transit tijd",
      "txt_charges_breakdown": "Kostenverdeling:",
      "lbl_total_cargo_charges": " Totale vrachtkosten:",
      "cta_view_details": "Details weergeven",
      "lbl_total_general_charges": "Totale algemene kosten:",
      "txt_transit_time": "Transit tijd:"
    },
    "cargo": {
      "txt_goods_description": "Productomschrijving:",
      "txt_volume": "Volume",
      "txt_dimensions": "Afmetingen",
      "txt_delivery": "Aflevering",
      "txt_extra_stops": "Extra stops",
      "txt_dg": "DG",
      "txt_total": "Totaal",
      "txt_yes": "Ja"
    },
    "teaser": {
      "txt_booked_on": "Geboekt op:",
      "txt_rejected_on": "Afgewezen op:",
      "txt_expired_on": "Verlopen op:",
      "txt_valid_until": "Valide tot:",
      "txt_any_origin": "Elke herkomst",
      "txt_any_destination": "Elke bestemming"
    },
    "conditional_charges": {
      "txt_conditional_charges": "Voorwaardelijke kosten",
      "txt_local_origin": "Lokaal bij herkomst ",
      "txt_local_destination": "Lokaal bij bestemming",
      "txt_rate": "Tarief",
      "txt_extra_info": "Extra Info",
      "txt_from": "Van",
      "txt_per": "per",
      "txt_base": "Basis:",
      "txt_minimum": "Minimum:",
      "txt_weight": "gewicht",
      "txt_charge": "Kosten",
      "txt_description": "Beschrijving",
      "txt_port": "haven",
      "txt_period": "Periode",
      "txt_free": "Gratis",
      "txt_per_day": "per dag",
      "txt_first": "Eerste",
      "txt_inland_transport": "Binnenlands transport"
    },
    "organization_obsolete": {
      "alert_organization_will_not_be_accessible": "Deze organisatie zal binnenkort niet meer toegankelijk zijn op myRotra",
      "txt_organization_is_obsolete1": "Deze organisatie is vervallen. Als je hulp nodig hebt, neem dan",
      "txt_organization_is_obsolete2": "met je accountmanager of ons Customer Success Team.",
      "cta_contact": "contact op",
      "txt_this_organization_is_marked_as_obsolete": "Deze organisatie is als vervallen gemarkeerd. Het is daarom niet langer mogelijk om deze organisatie te gebruiken voor het aanvragen van offertes of het maken van boekingen. Let op: 12 weken na de levering van al je actieve zendingen, offertes en contracten is deze organisatie niet meer toegankelijk op myRotra.",
      "txt_need_support": "Hulp nodig?"
    },
    "charges": {
      "txt_warning_inland_transport_unavailable": "Houd er rekening mee dat de kosten voor binnenlands transport nog niet zijn berekend, omdat deze niet beschikbaar zijn voor de geselecteerde postcode en het geselecteerde land ({{postcode}}, {{country_code}}).",
      "txt_inland_transport_could_not_be_calculated": "Binnenlands transport kon niet berekend worden",
      "txt_charges_not_calculated_not_available": "Houd er rekening mee dat de kosten voor binnenlands transport niet zijn berekend, omdat deze niet beschikbaar zijn voor de geselecteerde stad.",
      "txt_all_in_price_calculation_does_not_have_charges": "Houd er rekening mee dat in de all-in prijsberekening geen kosten voor binnenlands transport zijn inbegrepen. Er worden namelijk geen kosten berekend op basis van het opgegeven gewicht.",
      "alert_remark": "Opmerking:",
      "txt_general_charges": "Algemene kosten",
      "txt_charges_option": "Kosten optie",
      "txt_additional_charges_in_case_of_events": "Bijkomende kosten in geval van uitzonderlijke gebeurtenissen",
      "txt_will_be_added_in_case_of_events": "Worden toegevoegd bij bepaalde gebeurtenissen",
      "txt_origin": "Herkomst",
      "txt_destination": "Bestemming",
      "txt_freight": "Vracht",
      "txt_freight_surcharges": "Vrachtkosten",
      "txt_precarriage_charges": "Precarriage kosten",
      "txt_oncarriage_charges": "Oncarriage kosten",
      "txt_inland_transport": "Binnenlands transport",
      "txt_discharge_terminal_surcharges": "Kosten voor losterminals (niet inbegrepen in de totaalprijs)",
      "txt_conditional_charges": "Voorwaardelijke kosten",
      "txt_charge": "Kosten",
      "txt_description": "Omschrijving",
      "txt_amount": "Hoeveelheid",
      "txt_subtotal": "Subtotaal",
      "txt_cargo_charges": "Vrachtkosten"
    }
  },
  "delete_user_dialog": {
    "delete_confirmation": {
      "txt_title": "Weet u zeker dat u deze gebruiker wilt verwijderen?",
      "txt_message": "Hiermee verwijdert u {{user}} uit de organisatie {{organization_name}}. Deze gebruiker heeft daarna geen toegang meer tot de gegevens van deze organisatie in myRotra.",
      "alert_assign_to_user": "De onderstaande gegevens worden momenteel gevolgd door {{user}}. U wordt automatisch toegewezen om deze gegevens als admin-gebruiker te volgen. Als dit niet gewenst is, wijs dan andere gebruikers binnen uw organisatie toe om deze gegevens te monitoren."
    },
    "delete_notification": {
      "alert_succes": "Gebruiker succesvol verwijderd uit de organisatie",
      "alert_failure": "Het verwijderen van de gebruiker uit de organisatie is mislukt"
    }
  },
  "customer_success": {
    "txt_have_any_questions_contact_manager": "Indien u vragen heeft, kunt u contact opnemen met uw accountmanager.",
    "txt_can_also_contact_our_customer_success": "U kunt ook contact opnemen met ons Customer Success-team via onderstaande gegevens. Zij helpen u graag verder."
  },
  "contracts": {
    "txt_pageTitle_contracts": "contracten",
    "teaser": {
      "cta_view_shipment": "{{count}} zending weergeven",
      "cta_view_shipment_plural": "{{count}} zendingen weergeven",
      "cta_view_booking": "{{count}} boeking weergeven",
      "cta_view_booking_plural": "{{count}} boekingen weergeven",
      "cta_view_contract": "Contract weergeven",
      "txt_organization": "Organisatie",
      "alert_contract_expired_on": "Dit contract is verlopen op: {{date}}",
      "alert_contract_rejected_on": "Dit contact is afgewezen op: {{date}}",
      "cta_view_new_contract": "Nieuw contract weergeven",
      "cta_calculate_and_book": "Bereken & Boek",
      "txt_valid_until": "Valide tot",
      "txt_expires_today": "Verloopt vandaag",
      "txt_expires_in": "Verloopt in {{count}} dag",
      "txt_expires_in_plural": "Verloopt in {{count}} dagen",
      "txt_departing_airports": "Luchthavens van vertrek",
      "txt_ports_of_loading": "Laadhavens",
      "txt_arriving_airports": "Luchthavens van aankomst",
      "txt_ports_of_discharge": "Loshavens",
      "txt_contract_reference_incoterm": "Contract referentie - Incoterm",
      "lbl_reference": "Referentie"
    },
    "single_channel": {
      "txt_book_from_contract": "Boek vanuit contract",
      "txt_select_option_to_book": "Selecteer de optie die je wilt boeken",
      "txt_continue_to_booking": "Verdergaan naar boeking",
      "alert_based_on_contract_visible_option": "Gebasseerd op het geselecteerde contract zijn de volgende boekoptie beschikbaar, selecteer er een om verder met het boekingsproces te gaan.",
      "alert_based_on_contract_visible_option_other": "Gebasseerd op het geselecteerde contract zijn de volgende boekopties beschikbaar, selecteer er een om verder met het boekingsproces te gaan."
    },
    "contracts_detail": {
      "txt_created": "Aangemaakt op:",
      "txt_last_updated": "Laatst geüpdatet:",
      "txt_contract_cannot_be_used": "Dit contract kan niet gebruikt worden om een boeking te plaatsen, omdat de organisatie is vervallen.",
      "alert_view_new_contract": "Nieuw contract weergeven",
      "alert_contract_expired_on": "Dit contract is verlopen op: {{date}}",
      "txt_rejected_this_contract_on": "{{user}} contract afgewezen op {{date}}<br />Reden: <i>{{reason}}</i>",
      "txt_percent_of_container_price": "{{percentage}}% van de containerprijs, minimum {{price}}",
      "alert_contract_was_rejected_on": "Dit contract is afgewezen op {{date}}",
      "alert_last_booking_was_requested_on": "Je laatste boeking was aangevraagd op:",
      "lbl_valid_until": "Valide tot:",
      "txt_expires_today": "Verloopt vandaag",
      "txt_you": "Jij",
      "txt_succesfully_rejected_contract": "Je hebt dit contract succesvol afgewezen",
      "txt_reason_to_reject_contract": "Je staat op het punt dit contract af te wijzen, graag een reden opgeven.",
      "txt_succesfully_rejected": "Succesvol afgewezen",
      "cta_reject": "Wijs af",
      "lbl_reason": "Reden",
      "txt_maximum_amount_of_text_for_reason": "Je bent over de maximum hoeveelheid tekst gegaan, maak je reden korter.",
      "alert_contract_cannot_be_booked": "Dit contract kan niet geboekt worden omdat alle vrachtopties verlopen zijn. Neem contact op met je contactpersoon.",
      "txt_cannot_be_accessed_because_organization_is_obsolete": "Deze functionaliteit is niet toegankelijk omdat je organisatie is vervallen. Neem contact op met je account manager of met ons Customer Succes team voor verdere hulp. ",
      "cta_reject_contract": "Reject contract",
      "cta_calculate_and_book": "Bereken & Boek",
      "cta_view": "Weergeven",
      "txt_shipment": "zending",
      "cta_view_shipment_one": "{{count}} zending weergeven",
      "cta_view_shipment_plural": "{{count}} zendingen weergeven ",
      "cta_view_booking_one": "{{count}} boeking weergeven",
      "cta_view_booking_plural": "{{count}} boekingen weergeven ",
      "cta_download": "Download",
      "cta_view_contract_pdf": "Contract bekijken",
      "cta_view_pdf": "Bekijk",
      "lbl_contact": "Contact",
      "txt_routings": "Route",
      "txt_coloader": "Bijlader",
      "txt_minimum_rate": "Minimum Rate",
      "txt_departing_airports": "Luchthavens van vertrek",
      "txt_ports_of_loading": "Laadhavens",
      "txt_arriving_airports": "Luchthavens van aankomst",
      "txt_ports_of_discharge": "Loshavens",
      "txt_no_routings_in_contract": "Geen routes in contract",
      "txt_freight_charges": "Vrachtkosten",
      "txt_remark": "Opmerking:",
      "txt_surcharges": "Kosten",
      "txt_any_port": "Elke haven",
      "txt_carriage": "Vervoer",
      "txt_including_tare": "inclusief tarra",
      "txt_excluding_tare": "exclusief tarra",
      "txt_per_kg_per_container": "per KG per Container",
      "txt_up_to_interval": "tot {{steps}}",
      "txt_over": "meer dan",
      "txt_minimum_price": "Minimum prijs:",
      "txt_calculated_over": "Berekend over",
      "txt_precarriage_charges": "Pre-Carriage kosten",
      "txt_all_container_types": "Alle container types",
      "txt_oncarriage_charges": "On-Carriage kosten",
      "txt_local_charges": "Lokale kosten",
      "txt_origin": "Herkomst",
      "alert_remark": "Opmerking:",
      "txt_destination": "Bestemming",
      "txt_charge": "Kosten",
      "txt_rate": "Tarief",
      "txt_from": "Vanaf",
      "txt_base": "Basis:",
      "txt_per": "per",
      "txt_minimum": "Minimum:",
      "txt_chargeable_weight": "Belastbaar gewicht",
      "txt_actual_weight": "Daadwerkelijk gewicht",
      "txt_road_charges": "Wegtransport kosten",
      "txt_city": "Stad",
      "txt_price": "Prijs",
      "txt_container": "container",
      "txt_surcharge_info": "{{percentage}}% van de container prijs met een minimum van {{price}}",
      "txt_fuel_surcharge_description": "Een brandstof toeslag van {{percentage}}% is berekend over het transport tarief en terminal toeslag. De brandstof toeslag is variable per maand. De minimum brandstof toeslag is: {{minimumPrice}}.",
      "txt_zip_codes_zone": "Postcodegebied:",
      "txt_cubic_meter": "Kubieke meter",
      "txt_loadmeter": "Laadmeter",
      "txt_fuel_surcharge_note": "Exclusief brandstof toeslag van {percentage}}%, welke is berekend over het transport tarief. Brandstof toeslag is variabel per maand. De minimum brandstof toeslag is: {{minimumPrice}}.",
      "txt_zip_codes_zone_description": "Kosten toepasbaar voor adressen binnen het postcodegebied:",
      "txt_weight_up_to": "Gewicht tot",
      "txt_fuel_surcharge_excluding": " Exclusief brandstof toeslag van {percentage}}%, welke is berekend over het transport tarief met een minimum van {{minimumPrice}}.",
      "txt_additional_costs": "Voor onze bijkomende kosten, raadpleeg",
      "txt_demurrage_detention": "Demurrage & Detention",
      "txt_extra_info": "Extra informatie",
      "txt_port": "Haven",
      "txt_period": "Periode",
      "txt_free": "Gratis",
      "txt_per_day": "per dag",
      "txt_first": "Eerste",
      "txt_general_conditions": "Algemene voorwaarden",
      "txt_option": "Optie",
      "txt_expires": "Verloopt {{date}}",
      "alert_option_expired_on": "Deze optie is verlopen op:",
      "txt_freight_surcharges": "Vrachtkosten",
      "txt_surcharge": "Brandstof",
      "txt_weight": "Gewicht",
      "txt_upto": "Tot",
      "cta_contact": "Contact",
      "txt_no_contracts": "Je hebt geen contracten. Je kunt contact opnemen met onze verkoopafdeling om een contract aan te vragen.",
      "txt_no_contracts_to_show": "Geen contracten om weer te geven",
      "txt_need_support": "Hulp nodig?",
      "txt_displayed_on_the_page_once_available": "Je contracten worden op deze pagina weergegeven zodra ze beschikbaar zijn.",
      "txt_try_changing_search_phrase": "Probeer je zoekopdracht te veranderen of check je filters"
    }
  },
  "valid_organization_button": {
    "valid_organization_button": "Deze functionaliteit is niet toegankelijk omdat je organisatie is vervallen. Neem contact op met je account manager of met ons Customer Succes team voor verdere hulp."
  },
  "bookings": {
    "lbl_with_rate": "Met tarief",
    "lbl_without_rate": "Zonder tarief",
    "txt_cant_find_booking": "We kunnen die boeking niet vinden",
    "txt_try_changing_search_phrase": "Probeer je zoekopdracht te veranderen of check je filters.",
    "txt_bookings": "boekingen",
    "teaser": {
      "lbl_booking_without_rate": "Boeking zonder tarief ",
      "txt_booked_on": "Geboekt op:",
      "txt_last_updated": "Bijgewerkt op:",
      "txt_shipper": "Verlader",
      "txt_cargo_description": "Omschrijving van de vracht:",
      "txt_cargo_unknown": "Onbekende vracht",
      "txt_show_less": "Minder weergeven",
      "txt_show_more": "Meer weergeven",
      "txt_pickup_and_delivery": "Ophalen & levering",
      "lbl_pickup_shipper_address": "Ophalen /\nVerlader adres",
      "lbl_delivery_consignee_address": "Aflevering /\nOntvanger adres"
    },
    "detail": {
      "lbl_booking_without_rate": "Boeking zonder tarief",
      "txt_requested_this_booking_on": "{{name}} heeft deze boeking aangevraagd op {{date}}",
      "txt_you_requested_this_booking_on": "Je hebt deze boeking aangevraagd op {{date}}",
      "lbl_thank_you_for_creating_booking_with_us": "Bedankt voor het plaatsen van een boeking met ons! Via deze pagina zal je op de hoogte worden gehouden van verdere vooruitgangen.",
      "cta_view_shipment": "zending weergeven",
      "txt_your_shipment_is_ready": "Je zending is gereed",
      "txt_pieces": "st.",
      "txt_yes": "Ja",
      "txt_no": "Nee",
      "txt_transit_time": "Transittijd",
      "lbl_additional_information": "Aanvullende informatie",
      "txt_quotation": "Offerte",
      "txt_airline": "Luchtvaartmaatschappij",
      "txt_via": "Via",
      "txt_coloader": "Mede-verlader",
      "txt_documents": "Documenten",
      "txt_no_shipment_documents": "Nog geen zendingsdocumenten toegevoegd door.",
      "cta_show_less": "Minder weergeven",
      "txt_more": "meer",
      "txt_container": "container",
      "txt_pickup_address": "Ophaaladres",
      "txt_delivery_address": "Afleveradres",
      "txt_shipper": "Verlader",
      "txt_consignee": "Ontvanger",
      "lbl_pickup_city": "Pickup Stad",
      "lbl_delivery_city": "Aflevering Stad ",
      "txt_pc": "st.",
      "txt_additional_information": "Aanvullende informatie",
      "cta_view": "Weergeven",
      "txt_quote": "Offerte",
      "txt_view_more_details": "Meer details weergeven",
      "txt_hide_details": "Details verbergen",
      "txt_cargo_contains_dangerous_goods": "Vracht bevat gevaarlijke goederen",
      "cta_add_cargo_description": "Voeg vrachtsomschrijving toe",
      "cta_add_cargo": "Vracht toevoegen",
      "txt_goods_description": "Productsomschrijving",
      "txt_not_set": "niet ingesteld",
      "txt_no_shipper_linked_yet": "Nog geen verlader gekoppeld",
      "txt_no_consignee_linked_yet": "Nog geen ontvanger gekoppeld",
      "txt_package_contains_dangerous_goods": "Dit pakket bevat gevaarlijke goederen",
      "txt_remarks": "Opmerkingen",
      "txt_city": "Stad",
      "txt_pickup_and_delivery": "Ophalen & levering",
      "lbl_pickup_shipper_address": "Ophalen / Verlader adres",
      "lbl_delivery_consignee_address": "Aflevering / Ontvanger adres",
      "lbl_origin": "Oorsprong",
      "lbl_destination": "Bestemming",
      "txt_total": "Totaal:",
      "txt_no_costs_yet": "Er is nog geen kosteninformatie beschikbaar voor deze boeking."
    }
  },
  "shipments": {
    "txt_we_cant_find_shipment": "We kunnen die zending niet vinden",
    "txt_try_changing_search_phrase": "Probeer je zoekopdracht te veranderen of check je filters.",
    "txt_shipments": "zendingen",
    "txt_canceled": "Geannuleerd",
    "txt_new_eta_is_delayed": "Nieuwe ETA is minstens 24 uur later dan initieel gepland",
    "txt_new_eta_is_early": "Nieuwe ETA is minstens 24 uur eerder dan initieel gepland",
    "txt_delayed": "Vertraagd",
    "txt_early": "Vroeg",
    "txt_amount_of_containers": "Aantal containers:",
    "txt_containers": "Containers:",
    "txt_unknown": "Onbekend",
    "txt_one_free_day_left": "Er is nog maar één vrije dag Demurrage/Detention voor minstens één of meerdere containers.",
    "txt_no_free_days_left": "Er zijn geen vrije dagen Demurrage/Detention meer voor minstens één of meerdere containers",
    "txt_arriving_today": "Aankomst vandaag",
    "lbl_routing_will_soon_be_available": "Route is binnenkort beschikbaar",
    "txt_no_information_found": "Geen informatie gevonden",
    "txt_no_icon": "geen icoon",
    "txt_open_task": "Je hebt {{count}} open taak voor deze zending",
    "txt_open_tasks": "Je hebt {{count}} open taken voor deze zending",
    "txt_by_sender_on": "op {{sender}} door {{date}}",
    "txt_by": "door",
    "txt_on": "op",
    "txt_emission_data_available": "Emissiegegevens beschikbaar voor deze zending.",
    "txt_calcualting": "Bezig met berekenen...",
    "txt_emission_data_not_available": "Emissiegegevens worden momenteel berekend voor deze Zending.",
    "txt_day_one": "{{count}} dag",
    "txt_day_other": "{{count}} dagen",
    "txt_day_routing_one": "{{count}} dag",
    "txt_day_routing_other": "{{count}} dagen",
    "txt_etd_diff_days": "ETD: {{date}} ({{diff}} dagen)",
    "txt_to_be_determined": "Wordt nog bepaald",
    "txt_eta_date_diff_days": "ETA: {{date}} ({{diff}} dagen)",
    "shipment_detail": {
      "lbl_tab_cargo": "Vracht",
      "lbl_tab_todo": "Takenlijst",
      "lbl_tab_documents": "Documenten",
      "lbl_tab_costs": "Kosten",
      "lbl_charge": "Tarief",
      "lbl_description": "Omschrijving",
      "lbl_original_amount": "Origineel bedrag",
      "lbl_conv_rate": "Wisselkoers",
      "lbl_invoice_amount": "Bedrag",
      "txt_subtotal": "Subtotaal",
      "lbl_invoice": "Factuur",
      "cta_download": "Downloaden",
      "txt_no_invoice_lines": "Er zijn nog geen facturen beschikbaar voor deze zending.",
      "txt_peppol_invoice_info": "De originele factuur is verzonden naar uw Peppol-adres. Deze factuur is alleen voor weergavedoeleinden.",
      "txt_invoice_disclaimer_demo": "Deze factuur maakt deel uit van de demo-omgeving en weerspiegelt mogelijk niet de werkelijke kosten voor uw zending of scenario's uit de echte wereld.",
      "txt_invoice_recently_uploaded": "Geüpload binnen de laatste {{hours}} uur",
      "txt_early": "Vroeg",
      "txt_delayed": "Vertraagd",
      "txt_last_updated": "Laatst geüpdatet: {{date}}",
      "lbl_consolidated": "Geconsolideerd",
      "txt_shipment_consolidated": "Zending geconsolideerd",
      "txt_what_is_consolidated_shipment": "Wat is een geconsolideerde zending?",
      "lbl_consolidated_shipment_description": "Een <strong>geconsolideerde zending</strong> combineert meerdere LCL zendingen in één volle container om ruimte te optimaliseren, kosten te reduceren en efficiëntie te verbeteren. Wanneer de container bij de bestemming aankomt, zullen de LCL zendingen afgeleverd worden bij hun uiteindelijke afleveradres(sen).",
      "txt_shipment_is_consolidated_with_other": "Deze zending is geconsolideerd met andere zendingen in een container",
      "txt_in": "in",
      "txt_client_ref": "Klant ref",
      "txt_link_created_succesfully": "Je link is succesvol aangemaakt, deze kan je nu kopiëren.",
      "txt_shipment_is_shared": "Je zending is gedeeld, we hebben een e-mail gestuurd naar het opgegeven adres.",
      "txt_click_to_check_the_email": "Klik hier om het e-mail adres te bekijken waarmee de zending is gedeeld",
      "txt_click_to_share_shipment": "Klik hier om deze zending te delen",
      "txt_share_shipment": "Zending delen",
      "lbl_shipment_shared_with": "Deze zending is gedeeld met de volgende e-mail adressen:",
      "cta_share": "Deel",
      "txt_note": "Opmerking:",
      "txt_by": "door",
      "txt_on": "op",
      "txt_by_sender_on": "door {{sender}} op {{date}}",
      "txt_days_left_one": "{{count}} dag over",
      "txt_days_left_other": "{{count}} dagen over",
      "txt_days_late_one": "{{count}} dag te laat",
      "txt_days_late_other": "{{count}} dagen te laat",
      "cta_more_documents_one": "+ {{count}} extra document",
      "cta_more_documents_other": "+ {{count}} extra documenten",
      "cta_show_less_documents": "Minder documenten weergeven",
      "txt_cargo_description": "Vrachtomschrijving:",
      "txt_expires": "Verloopt",
      "txt_no_free_days_left": "Er zijn geen vrije dagen Demurrage/Detention meer voor minstens één of meerdere containers.",
      "txt_revoke_access": "Toegang intrekken",
      "txt_are_you_sure_revoke_access": "Weet je zeker dat je de toegang tot deze inhoud wilt intrekken?",
      "txt_link_copied": "Link gekopieerd",
      "txt_copy_link": "Kopieer link",
      "lbl_share_shipment_details": "Deel informatie over de zending moeiteloos: Geef email adressen op waarmee wij een publieke URL kunnen delen, of genereer en deel de link zelf. Toegang duurt tot 3 maanden.",
      "lbl_email_addresses": "E-mail addressen",
      "txt_invalid_email": "Ongeldige e-mail",
      "alert_shipment_already_shared": "Deze zending is al gedeeld met:",
      "lbl_how_to_share": "Hoe te delen?",
      "cta_by_link": "via Link",
      "cta_by_mail": "via Mail",
      "txt_add_note": "Voeg een opmerking bij de e-mail toe (optioneel)",
      "lbl_note": "Opmerking",
      "cta_open_report": "open rapport",
      "alert_emission_report_available": "Emissie rapport beschikbaar voor deze zending.",
      "alert_emission_report_not_available": "Er is nog geen emissierapport beschikbaar voor deze zending.",
      "txt_calculating_emission": "We berekenen momenteel de emissie voor deze zending, kom later nog eens terug.",
      "alert_emission_report_body": "De totale emissie voor deze zending is: {{total}} kg CO2, open het rapport voor meer details.",
      "txt_co2_total": "CO2e totaal",
      "txt_emission": "Emissie",
      "txt_from": "Van:",
      "txt_distance": "Afstand",
      "lbl_transit_hub": "Overslagpunt",
      "txt_to_city": "naar",
      "txt_emission_report": "Emissierapport",
      "txt_emission_report_description": "Emissies worden alleen berekend voor het transport dat door Rotra is uitgevoerd volgens de overeengekomen incoterm.",
      "txt_emission_report_not_available": "Geen emissiegegevens beschikbaar voor deze zending.",
      "txt_description_emission_report_not_available": "Op basis van de incoterm heeft Rotra geen transport voor deze zending verzorgd. Daarom wordt de emissie standaard op nul gezet.",
      "txt_emission_glec_framework": "De verstrekte emissiegegevens zijn gebaseerd op het GLEC-framework. De nauwkeurigheid kan variëren; gebruikers wordt geadviseerd experts te raadplegen voor specifieke toepassingen. Voor meer informatie over het GLEC-framework, raadpleeg:",
      "txt_any_questions": "Heeft u vragen? Neem dan gerust contact met ons op.",
      "txt_location_info": "De locatie is gebaseerd op de postcode van het adres.",
      "txt_to": "Naar:",
      "txt_total": "Totaal:",
      "cta_smart_freight_centre": "Smart Freight Centre",
      "txt_one_free_day_left": "Er is nog maar één vrije dag Demurrage/Detention voor minstens één of meerdere containers.",
      "cta_view": "bekijk",
      "txt_less": "minder",
      "txt_more": "meer",
      "alert_track_and_trace_unavailable": "Scheepstracking op de kaart is momenteel niet beschikbaar",
      "txt_port_of_loading": "Laadhaven",
      "txt_port_of_discharge": "Loshaven",
      "txt_location_update": "Locatie-update",
      "txt_current_location": "Huidige locatie",
      "txt_current_location_delayed": "Huidige locatie vertraagd",
      "txt_origin": "Herkomst",
      "txt_destination": "Bestemming",
      "txt_press_for_legend": "Klik hier voor legenda",
      "txt_legend": "Legenda",
      "txt_transit": "Transit",
      "txt_flight_nr": "Vlucht Nr",
      "txt_vessel": "Schip",
      "txt_airline": "Luchtvaartmaatschappij ",
      "txt_carrier": "Vervoerder",
      "lbl_shipper": "Verlader ",
      "lbl_bill_of_lading": "Vrachtbrief ",
      "txt_master": "Master:",
      "txt_house": "House:",
      "lbl_consignee": "Ontvanger",
      "cta_view_sale": "Bekijk",
      "txt_contract": "contract",
      "txt_quote": "offerte",
      "txt_created_from": "Aangemaakt vanuit",
      "txt_goods": "Goederen",
      "txt_transport": "Transport",
      "txt_no_containers": " Deze zending heeft nog geen containers",
      "txt_cargo_id": "Vracht ID",
      "txt_container_no": "Container Nr.",
      "txt_packages_from": "Verpakkingen van",
      "txt_total_volume": "Totale volume",
      "txt_marks_and_numbers": "Merken en nummers",
      "lbl_no_free_days_for_container": " Er zijn geen vrije dagen Demurrage/Detention meer voor deze meerdere container",
      "lbl_container_incurred": "Deze container heeft dem/det kosten opgelopen",
      "alert_timezone_info": "Demurrage & detention tijden worden weergegeven in CET-tijd. Uw tijdzone is {{timezone}}, wat {{diff}} uur{{plural}} {{direction}} van CET is.",
      "txt_free_days_demurrage_notice": "De vrije dagen beginnen te tellen wanneer de container aankomt in de loshaven.<1/>Demurrage begint zodra alle vrije dagen zijn opgebruikt.",
      "txt_demurrage_notice": "Demurrage begint op {{startDate}} zodra alle vrije dagen zijn opgebruikt.<0/>Het tellen van de dagen eindigt wanneer de container de terminal verlaat.",
      "txt_demurrage_started": "Demurrage begon op {{startDate}}.<0/>Het tellen van de dagen eindigt wanneer de container de terminal verlaat.",
      "txt_demurrage_summary": "{{totalDays}} dagen werden gebruikt, <0>{{daysOverdue}} {{dayLabel}}</0> waarvan demurragekosten inbegrepen waren.<1/>Het tellen eindigde toen de container de terminal verliet op {{endDate}}.",
      "txt_free_days_detention_notice": "De vrije dagen beginnen te tellen wanneer de container de terminal verlaat.<1/>Detention begint zodra alle vrije dagen zijn opgebruikt.",
      "txt_detention_starts_notice": "Detention begint op {{startDate}} zodra alle vrije dagen zijn opgebruikt.<1/>Het tellen van de dagen eindigt wanneer de container leeg wordt teruggebracht.",
      "txt_detention_started_notice": "Detention begon op {{startDate}}.<1/>Het tellen van de dagen eindigt wanneer de container leeg wordt teruggebracht.",
      "txt_detention_summary": "{{totalDays}} dagen werden gebruikt, <0>{{daysOverdue}} {{dayLabel}}</0> waarvan detention kosten inbegrepen waren.<1/>Het tellen eindigde toen de container leeg werd teruggebracht op {{endDate}}.",
      "txt_free_days_both_notice": "De vrije dagen beginnen te tellen wanneer de container aankomt in de loshaven.<0/>Demurrage en detention beginnen zodra alle vrije dagen zijn opgebruikt.",
      "txt_both_started_notice": "Demurrage en detention beginnen op {{startDate}} zodra alle vrije dagen zijn opgebruikt.<0/>Het tellen van de dagen eindigt wanneer de container leeg wordt teruggebracht.",
      "txt_both_started_notice_past": "Demurrage en detention begonnen op {{startDate}}.<0/>Het tellen van de dagen eindigt wanneer de container leeg wordt teruggebracht.",
      "txt_both_summary": "{{totalDays}} dagen werden gebruikt, <0>{{daysOverdue}} {{dayLabel}}</0> waarvan demurrage en detention inbegrepen waren.<1/>Het tellen eindigde toen de container leeg werd teruggebracht op {{endDate}}.",
      "txt_only_business_days": "<0/>Alleen werkdagen worden gebruikt voor het berekenen van de vrije dagen",
      "txt_weekend": "Weekend",
      "lbl_type_cannot_be_calculated": "{{typeLabel}} kan op dit moment niet worden berekend",
      "txt_no_packages_yet": "Deze zending heeft nog geen verpakkingen",
      "txt_no_cargo_yet": "This container does not have any cargo yet",
      "txt_cargo_from_consolidated_shipments": "Vracht van geconsolideerde zendingen",
      "alert_no_transport_yet": "Deze container heeft nog geen vracht",
      "txt_inland_transport_at_origin": " Binnenlands transport bij herkomst",
      "txt_container_number": "Container Nr",
      "txt_pickup_address": "Ophaaladres ",
      "txt_pickup_date": "Ophaaldatum",
      "txt_status": "Status",
      "alert_container_no_transport_yet": "Deze container heeft nog geen vervoer op het {{segmentType}}",
      "txt_delivery_address": "Afleveradres",
      "txt_reference": "Referentie",
      "txt_remark": "Opmerking: {{remark}}",
      "lbl_remark": "Opmerking",
      "txt_inland_transport_at_destination": "Binnenlands transport bij bestemming",
      "txt_goods_description": "Productomschrijving",
      "txt_width": "Breedte",
      "txt_length": "Lengte",
      "txt_weight": "Gewicht",
      "txt_height": "Hoogte",
      "txt_volume": "Volume",
      "txt_no_transport_yet": "Deze zending heeft nog geen transport",
      "txt_delivery_date": "Leveringsdatum",
      "txt_no_transport_yet_for_cargo": "Deze vracht heeft nog geen transport op het {{segmentType}}",
      "txt_no_cargo_yet_for_shipment": "Deze zending heeft nog geen vracht",
      "txt_no_packages_yet_for_cargo": "Deze vracht heeft nog geen verpakkingen",
      "txt_no_cargo": "Deze vracht heeft nog geen transport ",
      "txt_to_do_list": "To Do Lijst",
      "txt_to_do": "To Do",
      "txt_done": "Gedaan",
      "txt_no_tasks_left_for_this_shipment": "Je hebt geen taken meer voor deze zending ",
      "txt_no_completed_tasks_left_for_this_shipment": "Je hebt geen voltooide taken voor deze zending",
      "txt_succesfully_reopened_this_task": " Je hebt deze taak succesvol opnieuw geopend.",
      "txt_succesfully_completed_task": "Je hebt de taak succesvol afgerond: {{task}}.",
      "txt_due": "Vervaldatum",
      "txt_today": "Vandaag",
      "txt_deadline_not_available": "Deadline niet beschikbaar",
      "txt_reopened_by_rotra": "Heropend door Rotra: {{remark}}",
      "txt_completed_on": "Afgerond op {{date}} door",
      "txt_upload": "Uploaden",
      "txt_upload_file": "Bestand uploaden",
      "cta_complete": "Afronden",
      "cta_mark_as_done": "Markeer als gedaan",
      "cta_reopen": "Heropen",
      "cta_mark_as_to_do": "Markeer als to do",
      "txt_view_task": "Taak bekijken",
      "cta_more": "+ {{count}} meer",
      "cta_show_less": "Toon minder",
      "txt_documents": "Documenten",
      "lbl_shipment_documents": "Zendingdocumenten",
      "lbl_uploaded_documents": "Geüploade documenten",
      "txt_uploaded_on": "Geüpload op {{date}} door",
      "txt_container": "Container",
      "txt_no_shipment_documents_added": "Er zijn nog geen zendingdocumenten toegevoegd of geaccepteerd door Rotra.",
      "txt_upload_your_documents_to_see_them": "Upload je documenten om ze hier te zien.",
      "txt_documents_are_uploaded": "Documenten zijn succesvol geüpload!",
      "txt_click_here_to_select_documents": "Klik hier om documenten te selecteren of sleep een bestand hier om te uploaden",
      "txt_maximum_upload_file": "Maximale bestandsgrootte voor uploaden: 10MB",
      "txt_failed_to_upload_documents": "Het uploaden van de volgende documenten is mislukt:",
      "txt_failed_because": "{{file}} mislukt omdat",
      "txt_select_document_type": "Selecteer een documenttype",
      "lbl_document_type": "Documenttype",
      "txt_select_all": "Selecteer alles",
      "txt_available_containers": "Beschikbare containers",
      "txt_awaiting_container_numbers": "Wachten op container nummers",
      "txt_upload_documents_to_see_them_here": "Upload documenten om ze hier te zien",
      "txt_please_select_document_type": "Selecteer een documenttype voor elk document om door te gaan",
      "txt_want_to_leave": "Weet je zeker dat je wilt verlaten?",
      "cta_leave_shipment": "Ja, verlaat zending",
      "cta_continue_with_shipment": "Ga door met zending",
      "txt_description_uploaded_documents": "Je documenten zijn nog niet geüpload naar deze zending. Druk op de Opslaan knop in het documentgebied om de upload te voltooien. Als je nu vertrekt, zijn je documenten niet geüpload.",
      "txt_file_is_too_big": "Het bestand is te groot, de maximale grootte is 10MB.",
      "txt_unsupported_file_type": "Niet-ondersteund bestandstype.",
      "txt_invalid_character": "De bestandsnaam bevat een ongeldige teken. Hernoem het bestand en probeer opnieuw.",
      "txt_error_occurred": "Er is een onverwachte fout opgetreden.",
      "messages": {
        "txt_messages": "Berichten",
        "cta_minimize": "Minimaliseren",
        "txt_no_messages_yet": "Er zijn nog geen berichten.",
        "txt_messages_failed_to_load": " Berichten konden niet worden geladen.",
        "cta_scroll_to_new_messages": "Scroll naar nieuwe berichten",
        "txt_new_messages_count_one": "{{count}} nieuw bericht",
        "txt_new_messages_count_other": "{{count}} nieuwe berichten"
      }
    }
  },
  "rotra_map": {
    "txt_cluster_title": "Cluster van {{count}} zendingen",
    "cta_exit_fullscreen": "Verlaat volledig scherm",
    "cta_enter_fullscreen": " Ga naar volledig scherm",
    "txt_couldnt_load_google_maps": "Deze pagina kon Google Maps niet correct laden."
  },
  "address_book_page": {
    "txt_successfully_deleted_address": "Adres succesvol verwijderd",
    "lbl_delete_address_title": "{{name}} verwijderen",
    "txt_delete_address_confirm": "Weet je zeker dat je dit adres voor {{name}} wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    "txt_address_book": "Adresboek",
    "cta_add_new_address": "Nieuw adres toevoegen",
    "txt_no_addresses_found": "Geen adressen gevonden.",
    "txt_addresses": "addressen",
    "cta_view_all_contacts": "Alle {{count}} contacten weergeven",
    "cta_hide_contacts": "Contacten verbergen",
    "txt_no_contact_person": "Geen contactpersoon",
    "detail": {
      "txt_successfully_saved_address": "Adres succesvol opgeslagen",
      "txt_successfully_updated_address": "Adres succesvol geüpdatet",
      "txt_new_address": "Nieuw adres",
      "txt_edit_address": "Adres bijwerken",
      "txt_view_address": "Adres bekijken",
      "txt_no_contact_person": "Geen contactpersoon",
      "txt_created": "Aangemaakt: {{date}}",
      "txt_updated": "Gewijzigd: {{date}}",
      "txt_address_book_item_not_found": "Adresboek item niet gevonden.",
      "txt_company": "Bedrijf",
      "lbl_company_name": "Bedrijfsnaam",
      "lbl_street_address": "Adres",
      "lbl_street_address2": "Adres 2",
      "lbl_country": "Land",
      "lbl_postal_code": "Postcode",
      "txt_city": "Stad",
      "txt_contacts": "Contacten",
      "lbl_contact_person_name": "Naam contactpersoon",
      "lbl_email": "E-mail",
      "lbl_phone": "Telefoon",
      "cta_delete_contact": "Contact verwijderen",
      "cta_add_another_contact_person": "Nieuw contactpersoon toevoegen",
      "cta_add_contact_person": "Contactpersoon",
      "txt_saving": "Aan het opslaan",
      "txt_duplicate_company_address": "Dit bedrijf en adres bestaan al — selecteer deze uit de suggesties om daar een contact toe te voegen",
      "txt_invalid_company_name": "Voer een geldige bedrijfsnaam in",
      "txt_invalid_street_address": "Voer een geldig straatadres in",
      "txt_invalid_city": "Voer een geldige plaats in",
      "txt_invalid_name": "Voer een geldige naam in",
      "lbl_netherlands": "Nederland",
      "lbl_belgium": "België",
      "lbl_germany": "Duitsland"
    }
  },
  "organizations": {
    "lbl_add_more": "Meer toevoegen",
    "lbl_team": "Team",
    "lbl_about": "Over",
    "lbl_api_keys": "API sleutels",
    "lbl_webhooks": "Webhooks",
    "lbl_select_organization": "Selecteer organisatie",
    "lbl_city": "Plaats",
    "lbl_vat_number": "Btw-nummer",
    "lbl_account_number": "Accountnummer",
    "cta_add_user": "Gebruiker toevoegen",
    "txt_actions": "Acties",
    "txt_cannot_remove_admin": "Kan de beheerder niet verwijderen, neem contact op met: cs@rotra.nl",
    "txt_activation_pending": "Activatie in afwachting",
    "txt_admin": "Beheerder",
    "txt_user": "Gebruiker",
    "cta_remove": "Verwijder",
    "txt_could_not_invite_users": "Kon niet alle gebruikers uitnodigen",
    "txt_users_invited_successfully": "Gebruikers s",
    "txt_add_users": "Voeg gebruikers toe aan de",
    "txt_organization": "organisatie",
    "cta_invite_users": "Nodig {{count}} gebruiker uit",
    "cta_invite_users_plural": "Nodig {{count}} gebruikers uit ",
    "cta_invite": "Uitnodigen",
    "txt_active_users": "Actieve gebruikers",
    "txt_pending_users": "Wachtende gebruikers",
    "txt_no_users_found": "Geen gebruikers gevonden, vul een e-mailadres in",
    "lbl_email_address_or_name": "E-mailadres of naam",
    "cta_add_another_user": "+ Gebruiker toevoegen",
    "lbl_user_already_in_organization": "Gebruiker is al in de organisatie",
    "lbl_user_already_in_list_to_invite": "Gebruiker staat al op de uitnodigingslijst",
    "lbl_last_login": "Laatste Login",
    "lbl_role": "Rol",
    "lbl_name": "Naam",
    "alert_take_control_of_your_data": "Neem controle over je gegevens: Beheer gebruikers en verhoog de veiligheid met het Gebruikersbeheer van myRotra. ",
    "alert_manage_your_own_users": "Vanaf nu is het mogelijk om je eigen gebruikers te beheren in myRotra.",
    "cta_read_less": "Minder lezen",
    "cta_read_more": "Meer lezen",
    "txt_new_powerful_feature": "We zijn enthousiast om een nieuwe functie in myRotra aan te kondigen die je meer controle geeft over uw gegevens en de veiligheid van je organisatie verbetert. Maak kennis met Gebruikersbeheer: een gestroomlijnde oplossing waarmee je moeiteloos je gebruikers kunt beheren.",
    "txt_whats_new": "Wat is nieuw?",
    "txt_oversee_and_control_user_access": "Met onze vernieuwde Gebruikersbeheer-oplossing heb je de mogelijkheid om het gebruikersbeheer en de toegang tot je gegevens volledig te controleren. Dit kun je verwachten:",
    "txt_manage_users": "Beheer gebruikers",
    "txt_protect_your_data": "Bescherm je data",
    "txt_more_insights": "Meer inzichten",
    "txt_enchanced_effiency": "Verbeterde efficiëntie",
    "txt_one_thing_we_need": "Er is maar één ding dat we nodig hebben",
    "txt_need_to_be_admin": "Om gebruikers in myRotra te beheren, moet je een beheerder zijn. Op dit moment is er geen beheerder ingesteld voor deze organisatie. We verzoeken je vriendelijk om contact op te nemen met je accountmanager of ons Customer Success-team om één of meer personen als beheerder voor je organisatie aan te wijzen.",
    "cta_contact_us_now": "Contacteer ons nu",
    "txt_contact_rotra": "Contacteer Rotra",
    "txt_about": "Over",
    "txt_legal_name": "Juridische naam",
    "txt_account_no": "Account nr.",
    "txt_address": "Adres",
    "txt_vat": "BTW-nr.",
    "txt_api_keys": "API-sleutels",
    "txt_loading_keys": "Sleutels laden...",
    "txt_no_active_api_keys_found": "Geen actieve API-sleutels gevonden",
    "txt_created": "Gecreëerd:",
    "txt_expired": "Verlopen:",
    "txt_primary_key": "Primaire sleutel",
    "txt_secondary_key": "Secundaire sleutel",
    "txt_copied": "Gekopieerd!",
    "txt_copy_to_clipboard": "Kopieer naar klembord",
    "txt_hide_key": "Verberg sleutel",
    "txt_show_key": "Sleutel weergeven",
    "alert_only_administrator_view_api_keys": "Alleen de beheerder van je organisatie kan API-sleutels bekijken. Neem contact met hen op om toegang tot de API te krijgen.",
    "alert_api_keys_integrate_rotra_service": "API-sleutels stellen je in staat om de diensten van Rotra rechtstreeks in je systemen te integreren.",
    "lbl_active": "Actief",
    "lbl_expired": "Verlopen",
    "txt_apikey_expired": "API-sleutel is verlopen en kan niet langer gebruikt worden",
    "lbl_suspended": "Suspended",
    "txt_apikey_suspended": "API-sleutel is opgeschort en kan niet worden gebruikt.",
    "lbl_pending": "In afwachting",
    "txt_apikey_pending": "API-sleutelverzoek is in afwachting van goedkeuring.",
    "lbl_rejected": "Afgewezen",
    "txt_apikey_rejected": "API-sleutelverzoek is afgewezen",
    "lbl_cancelled": "Geannuleerd",
    "txt_apikey_cancelled": "API-sleutel is geannuleerd ",
    "lbl_unknown": "Onbekend",
    "txt_apikey_unknown": "Onbekende status van API-sleutel",
    "txt_apikey_dummy": "Production API-sleutel (DUMMY)",
    "txt_apikey_pending_dummy": "Sleutel in afwachting van goedkeuring (DUMMY)",
    "txt_apikey_expired_dummy": "Verlopen Development sleutel (DUMMY)",
    "txt_apikey_suspended_dummy": "Opgeschorte Test sleutel (DUMMY)",
    "txt_need_access_to_more_organizations": "Toegang nodig tot meer organisaties in myRotra?",
    "txt_discover_possibilities": "Ontdek de mogelijkheden om meerdere bedrijven te koppelen aan <strong>één</strong> myRotra-account.",
    "txt_view_everything_using_one_account": "Bekijk alles met slechts één account",
    "txt_focus_on_what_is_important": "Richt je op wat belangrijk en urgent is",
    "txt_spend_less_time": "Besteed minder tijd aan het up-to-date blijven",
    "txt_coordinationg_work_across_multiple_businesses": "Het coördineren van werk tussen meerdere bedrijven is lastig. myRotra maakt het gemakkelijker.",
    "txt_using_myrotra": "myRotra gebruiken met meerdere organisaties stelt je in staat om samen te werken met verschillende bedrijven (<i>juridische entiteiten</i>).<br />Het maakt samenwerking eenvoudig en integreert al je informatie in hetzelfde portaal.",
    "txt_need_more_information": "Meer informatie nodig?",
    "txt_display_name": "Pas de weergavenaam van je organisatie aan op myRotra",
    "txt_display_name_subtitle": "Maak het je team gemakkelijk om deze organisatie te vinden",
    "lbl_display_name": "Weergavenaam",
    "txt_displayed_name_updated_successfully": "Weergavenaam succesvol bijgewerkt",
    "txt_change_affects_all_users": "Wijziging heeft invloed op alle gebruikers in je team. Gebruik een gemakkelijk herkenbare naam",
    "txt_all_team_members_see_display_name": "Alle teamleden zien dezelfde weergavenaam",
    "txt_visual_change_notice": "Wijziging is alleen visueel.<br />Het wijzigt <strong>niet</strong> je juridische gegevens in onze systemen",
    "txt_only_admins_can_change": "Alleen beheerders kunnen de weergavenaam wijzigen",
    "txt_account_number": "Accountnummer: {{clientId}}",
    "txt_admin_updated_display_name": "De beheerder van je organisatie heeft de weergavenaam bijgewerkt",
    "txt_change_display_name": "Wijzig de weergavenaam van je organisatie",
    "txt_admin_updated_display_name_subtitle": "In plaats van de juridische naam wordt de weergavenaam van je organisatie weergegeven, wat de herkenning op myRotra vereenvoudigt.",
    "alert_display_name_preview": "Gebruik altijd je accountnummer <strong>({{clientId}})</strong> van je organisatie of de Rotra-referentie bij contact met Rotra.",
    "txt_from": "Van",
    "txt_to": "Naar",
    "txt_get_api_access": "Om API-toegang voor je organisatie te krijgen, contacteer",
    "txt_api_access_allows_you": "API-toegang stelt je in staat om de diensten van Rotra direct in je systeem te integreren.",
    "txt_production_api_key": "Dit is uw productie API sleutel voor de rotraNext API.",
    "txt_disabled_because_the_form_is_read_only": "Uitgeschakeld omdat het formulier alleen-lezen is",
    "txt_active_organizations": "Actieve organisaties",
    "txt_obsolete_organizations": "Verouderde organisaties",
    "webhooks": {
      "txt_loading_webhooks": "Webhooks laden...",
      "alert_delete_error": "We konden de webhook-registratie op dit moment niet verwijderen. Probeer het later opnieuw.",
      "warning_alert": {
        "alert_title": "Belangrijk",
        "alert_message": "Webhook secrets kunnen slechts <strong>één keer</strong> worden bekeken—direct na het aanmaken van een nieuwe webhook of het opnieuw genereren van een secret. Zorg ervoor dat u ze veilig opslaat."
      },
      "txt_not_admin": "Alleen de beheerder van jouw organisatie kan Webhooks bekijken. Neem contact op met de beheerder om toegang tot Webhooks te krijgen.",
      "txt_subtitle": "Configureer webhook-eindpunten om realtime meldingen te ontvangen.",
      "info_alert": {
        "alert_title": "Webhook Levering & Formaat",
        "alert_message": "Webhooks bevatten alleen de entiteit-ID en minimale metadata. U moet een API-verzoek gebruiken met de entity_callback_url om volledige details op te halen. Als de levering mislukt, probeert ons systeem opnieuw met exponentiële backoff tot 5 keer.",
        "txt_example_payload": "Voorbeeld payload"
      },
      "cta_create_webhook": "Nieuwe webhook maken",
      "card": {
        "txt_created": "Aangemaakt",
        "txt_last_modified": "Laatst gewijzigd",
        "txt_info_tooltip": "Elke webhookaanvraag bevat een HMAC-signature voor verificatie. Klik om meer te leren.",
        "info_dialog": {
          "txt_subtitle": "Inzicht in en Verifiëren van Webhook Authenticiteit",
          "txt_body": "Om authenticiteit te garanderen, bevatten alle webhookaanvragen een HMAC-signature. U moet deze signature verifiëren voordat u het event verwerkt met behulp van de webhook secret en de webhook event payload (zonder de secret).",
          "txt_learn": "Leer hoe u signatures kunt verifiëren.",
          "cta_close": "Sluiten"
        },
        "cta_delete": "Webhook verwijderen",
        "txt_title": "Bewerk Event Types",
        "cta_copy": "Kopiëren naar klembord",
        "txt_copied": "Gekopieerd!",
        "txt_secret_message": "Kan alleen nieuw aangemaakte secrets weergeven",
        "cta_show": "Toon Secret",
        "cta_hide": "Verberg Secret",
        "cta_regenerate": "Secret opnieuw genereren"
      },
      "create_modal": {
        "txt_title": "Nieuwe Webhook Maken",
        "txt_description": "Uw endpoint moet HTTP POST-verzoeken accepteren om events te ontvangen.",
        "cta_cancel": "Annuleren",
        "cta_create": "Webhook maken",
        "alert_url_error": "Voer a.u.b. een geldige URL in inclusief http:// or https://."
      },
      "edit_modal": {
        "txt_title": "Bewerk Event Types",
        "cta_cancel": "Annuleren",
        "cta_save": "Wijzigingen opslaan"
      },
      "regenerate_modal": {
        "txt_title": "Secret Key Opnieuw Genereren",
        "txt_message": "Weet u zeker dat u de secret key voor <strong>{{ webhookId }}</strong> opnieuw wilt genereren?",
        "cta_cancel": "Annuleren",
        "cta_regenerate": "Sleutel opnieuw genereren",
        "alert_title": "Belangrijke Beveiligingswaarschuwing",
        "alert_body": "Het opnieuw genereren van de secret key maakt de huidige sleutel ongeldig. U moet uw webhook-eindpunt bijwerken om de nieuwe sleutel te gebruiken."
      },
      "delete_modal": {
        "cta_delete": "Webhook verwijderen",
        "txt_message": "Typ <strong>{{ confirmationValue }}</strong> om de verwijdering te bevestigen.",
        "cta_cancel": "Annuleren",
        "alert_title": "Waarschuwing: Deze actie kan niet ongedaan worden gemaakt.",
        "alert_body": "U staat op het punt de webhook <strong>{{ webhookId }}</strong> te verwijderen. Dit zal onmiddellijk alle events naar dit eindpunt stoppen.",
        "txt_confirmation_value": "DELETE"
      },
      "event_selector": {
        "txt_event_type_description": "Kies events om meldingen voor te ontvangen.",
        "lbl_event_type": "Zoek events...",
        "ph_search_event": "Zoek of selecteer events",
        "txt_common_events": "Veelvoorkomende events"
      },
      "empty_state": {
        "txt_title": "Geen Webhooks Geconfigureerd",
        "txt_subtitle": "Webhooks stellen uw applicaties in staat om realtime meldingen te ontvangen wanneer er events plaatsvinden in uw account.",
        "cta_create": "Maak uw eerste webhook"
      }
    }
  },
  "tasks": {
    "lbl_to_do": "Taken",
    "txt_to_do_list": "Takenlijst",
    "txt_to_do": "Open taken",
    "lbl_for_you": "Voor jou",
    "lbl_all": "Alles",
    "txt_no_tasks_for_shipments_you_watching": "Je hebt momenteel geen taken voor zendingen die je volgt",
    "txt_tasks": "taken",
    "txt_no_tasks_by_selected_filters": "We kunnen geen openstaande taken vinden voor de geselecteerde filters",
    "txt_no_tasks_right_now": "Je hebt momenteel geen taken",
    "lbl_task": "Taak",
    "txt_client_reference": "Klantreferentie",
    "txt_open_task_one": "{{count}} taak",
    "txt_open_task_other": "{{count}} taken",
    "txt_completed_task": "Je hebt de taak succesvol afgerond: {{taskName}}",
    "txt_succesfully_uploaded_documents": "Documenten succesvol geüpload, maar we konden de taak niet voltooien. Probeer het opnieuw.",
    "txt_upload_and_complete_files": "Indienen zal de volgende bestanden uploaden en deze taak als voltooid markeren.",
    "txt_save_and_complete": "Opslaan & voltooien",
    "txt_no_documents_to_upload": "Nog geen documenten geüpload",
    "cta_upload_more": "+ Meer uploaden",
    "txt_file_is_too_big": "Het bestand is te groot, de maximale grootte is 10 MB.",
    "txt_unsupported_file_type": "Niet-ondersteund bestandstype.",
    "txt_filename_contains_invalid_character": "De bestandsnaam bevat een ongeldig teken. Hernoem het bestand en probeer het opnieuw.",
    "txt_unexpected_error": "Er is een onverwachte fout opgetreden."
  },
  "messages": {
    "txt_messages": "Berichten",
    "lbl_for_you": "Voor jou",
    "lbl_all": "Alles",
    "txt_messages_list": "berichten",
    "txt_change_filters_cant_find_messages": "We kunnen dat bericht niet vinden, probeer je filters aan te passen",
    "txt_not_received_any_messages": "Je hebt nog geen berichten ontvangen over offerteaanvragen, offertes of zendingen die je volgt",
    "txt_no_messages": "Je hebt nog geen berichten ontvangen",
    "lbl_only_show_unread": "Toon enkel ongelezen berichten",
    "txt_marking_as_read": "Bezig met markeren als gelezen...",
    "cta_view_conversation": "Bekijk gesprek",
    "txt_from": "Van: {{name}}",
    "cta_mark_as_read": "Markeer als gelezen",
    "cta_mark_amount_as_read": "Markeer {{count}} als gelezen",
    "cta_mark_all_as_read": "Markeer alles als gelezen",
    "txt_client_reference": "Klantreferentie",
    "txt_quotation": "Offerte"
  },
  "notifications": {
    "txt_notifications": "Meldingen",
    "lbl_email": "E-mail",
    "lbl_notification_center": "Meldingencentrum",
    "txt_all_labels": "Alle {{label}}",
    "txt_enabled_notification_one": "+{{count}} andere",
    "txt_enabled_notification_other": "+{{count}} anderen",
    "cta_preferences": "Voorkeuren",
    "txt_notification_preferences": "Meldingsvoorkeuren",
    "alert_too_many_notifications": "Ontvang je te veel meldingen?",
    "txt_enable_email_and_portal": "Je kunt nu meldingen per e-mail en via het portaal inschakelen voor alleen gevolgde zendingen. Dit kan het aantal meldingen dat je ontvangt aanzienlijk verminderen.",
    "txt_note_notifications": "<strong>Let op:</strong> Je ontvangt nog steeds meldingen over offertes, contracten en wanneer een zending wordt aangemaakt.",
    "txt_receive_notifications_for_watched_shipments": "Ontvang alleen meldingen voor gevolgde zendingen:",
    "txt_receive_notifications_for_new_quotes_and_messages_within_these_quotes": "Ontvang meldingen voor nieuwe offertes en berichten binnen deze offertes",
    "txt_new_quote": "Nieuwe offerte",
    "txt_receive_update_when_quote_is_available": "Ontvang een update wanneer er een nieuwe offerte beschikbaar is",
    "txt_new_message": "Nieuw bericht",
    "txt_receive_update_when_new_message_is_available": "Ontvang een update wanneer er een nieuw bericht binnen de offerte beschikbaar is",
    "txt_receive_notifications_regarding_your_contracts": "Ontvang meldingen over je contracten",
    "txt_new_contract": "Nieuw contract",
    "txt_receive_update_when_new_contract_is_available": "Ontvang een update wanneer er een nieuw contract beschikbaar is",
    "txt_booking_statuses": "Boekingsstatussen",
    "txt_receive_notifications_on_status_changes": "Ontvang meldingen bij statuswijzigingen in je boekingen",
    "txt_canceled": "Geannuleerd",
    "txt_receive_update_when_booking_is_canceled": "Ontvang een update wanneer een boeking wordt geannuleerd",
    "txt_reopened": "Heropend",
    "txt_receive_update_when_booking_is_reopened": "Ontvang een update wanneer een boeking wordt heropend",
    "txt_receive_notifications_on_certain_events_within_your_shipments": "Ontvang meldingen bij bepaalde gebeurtenissen binnen je zendingen",
    "txt_receive_update_new_message_within_shipment": "Ontvang een update wanneer er een nieuw bericht binnen de zending beschikbaar is",
    "txt_new_task": "Nieuwe taak",
    "txt_receive_update_when_new_task_is_available": "Ontvang een update wanneer er een nieuwe taak beschikbaar is voor je zending",
    "txt_schedule_changes": "Schemawijzigingen",
    "txt_receive_update_when_schedule_changes_in_your_shipment": "Ontvang een update wanneer er een schemawijziging in je zending plaatsvindt",
    "txt_new_document_available": "Nieuw document beschikbaar",
    "txt_receive_update_when_document_is_available": "Ontvang een update wanneer er een document beschikbaar is voor je zending",
    "txt_receive_notification_when_document_becomes_availabe_for_shipment": "Je ontvangt een melding wanneer er een document beschikbaar komt voor je zending. Selecteer de specifieke documenttypes waarvoor je deze meldingen wilt ontvangen:",
    "txt_status_change": "Statuswijziging",
    "txt_receive_update_when_status_changes_in_your_shipment": "Ontvang een update wanneer er een statuswijziging in je zending plaatsvindt",
    "txt_receive_notification_when_status_of_shipment_changes": "Je ontvangt een melding wanneer de status van je zending verandert. Selecteer welke statuswijzigingen je hiervoor wilt ontvangen:",
    "lbl_documents": "documenten",
    "lbl_statuses": "statussen",
    "txt_pickup_date_changes": "Wijzigingen in ophaaldatum",
    "txt_receive_an_update_when_there_is_new_pickup_date": "Ontvang een melding wanneer er een nieuwe ophaaldatum voor uw zending is",
    "txt_delivery_date_changes": "Wijzigingen in bezorgdatum",
    "txt_receive_update_when_new_delivery_date_for_your_shipment": "Ontvang een update wanneer er een nieuwe bezorgdatum voor uw zending is",
    "whats_new": {
      "txt_whats_new": "Wat is nieuw",
      "txt_changelog": "Wijzigingslogboek",
      "txt_whats_new_at_myrotra": "Wat is nieuw bij MyRotra?",
      "txt_release_notes": "Release notes",
      "txt_nothing_new": "Niets nieuws om te tonen",
      "txt_release_notes_will_be_available": "De release notes worden op deze pagina weergegeven zodra ze beschikbaar zijn.",
      "txt_published_on": "Gepubliceerd op {{date}}",
      "txt_more_information": "Problemen of meer informatie nodig?<br />Neem contact met ons op via onderstaande knop:<br />",
      "txt_release_note_not_found": "Release note niet gevonden.",
      "teaser": {
        "txt_published_on": "Gepubliceerd op {{date}}"
      }
    },
    "cta_dismiss_all": "Alles sluiten",
    "txt_no_notifications_right_now": "Op dit moment geen meldingen",
    "txt_booking_is_canceled": "Boeking <i>{{ref}}</i> is geannuleerd.",
    "txt_booking_is_reopened": "Boeking <i>{{ref}}</i> is heropend en wordt binnenkort verwerkt.",
    "txt_booking_status_update": "Boeking <i>{{ref}}</i> heeft een statusupdate ontvangen.",
    "cta_click_for_more_details": "{{date}}, klik voor meer details",
    "txt_shipment_confirmed": "Boeking voor zending <i>{{ref}}</i> is bevestigd.",
    "txt_shipment_departed": "Zending <i>{{ref}}</i> is vertrokken.",
    "txt_shipment_arrived": "Zending <i>{{ref}}</i> is aangekomen.",
    "txt_shipment_delivered": "Zending <i>{{ref}}</i> is afgeleverd.",
    "txt_shipment_canceled": "Zending <i>{{ref}}</i> is geannuleerd.",
    "txt_shipment_status_update": "Zending <i>{{ref}}</i> heeft een statusupdate ontvangen.",
    "txt_shipment_is_released_third_party": "Zending <i>{{ref}}</i> is vrijgegeven door een derde partij.",
    "txt_eta_now_as_planned": "Zending <i>{{ref}}</i> heeft een nieuwe ETA: {{date}} (zoals oorspronkelijk gepland)",
    "txt_eta_later": "Zending <i>{{ref}}</i> heeft een nieuwe ETA: {{date}} ({{timeDiff}} later dan de vorige ETA)",
    "txt_eta_earlier": "Zending <i>{{ref}}</i> heeft een nieuwe ETA: {{date}} ({{timeDiff}} eerder dan de vorige ETA)",
    "txt_eta_no_longer_delayed": "Zending <i>{{ref}}</i> is niet langer vertraagd! Huidige ETA: {{date}}",
    "txt_eta_generic": "Zending <i>{{ref}}</i> heeft een nieuwe ETA: {{date}}",
    "txt_shipment_created_by_rotra": "Zending <i>{{ref}}</i> is aangemaakt door Rotra.",
    "txt_new_contract_available": "Een nieuw contract met referentie <i>{{ref}}</i> is beschikbaar.",
    "txt_attachment_added": "{{type}} is toegevoegd aan zending <i>{{ref}}</i>.",
    "txt_new_quote_with_ref": "Er is een nieuwe offerte beschikbaar met referentie <i>{{ref}}</i>. Je kunt deze nu bekijken en boeken.",
    "txt_new_quote_no_ref": "Er is een nieuwe offerte beschikbaar. Je kunt deze nu bekijken en boeken.",
    "txt_sub_picked_up_actual": "De lading voor zending <i>{{ref}}</i> is opgehaald.",
    "txt_sub_picked_up_estimated": "Nieuwe geschatte ophaaldatum voor zending <i>{{ref}}</i>.",
    "txt_sub_picked_up_planned": "De geplande ophaaldatum voor zending <i>{{ref}}</i> is vastgesteld.",
    "txt_sub_delivery_estimated": "Nieuwe geschatte leverdatum voor zending <i>{{ref}}</i>.",
    "txt_sub_delivery_planned": "De geplande leverdatum voor zending <i>{{ref}}</i> is vastgesteld.",
    "txt_sub_default": "Zending <i>{{ref}}</i> heeft een substatus-update ontvangen."
  },
  "settings": {
    "txt_settings": "Instellingen",
    "txt_profile": "Profiel",
    "txt_first_name": "Voornaam",
    "txt_last_name": "Achternaam",
    "txt_change_password": "Wachtwoord wijzigen",
    "txt_email_instructions": "Wanneer je op deze knop drukt, wordt er een e-mail met instructies verzonden.",
    "txt_profile_is_complete": "Profiel is voor {{percentage}}% compleet",
    "txt_open_tasks": "Openstaande taken",
    "txt_configure": "Configureer {{key}}",
    "txt_configure_profile_picture": "Profielfoto instellen",
    "txt_sent_email_to_reset_your_password": "We hebben zojuist een e-mail gestuurd om je wachtwoord te resetten.",
    "preferences": {
      "txt_user_preferences": "Gebruikersvoorkeuren",
      "txt_auto_translate": "Automatisch vertalen",
      "txt_auto_translate_description": "Berichten en release notes automatisch vertalen naar uw voorkeurstaal",
      "txt_language_selection": "Taal",
      "txt_default_translation_language": "Standaard vertaaltaal",
      "txt_default_translation_language_description": "Selecteer de standaardtaal voor vertalingen",
      "txt_measurement_system": "Standaard maatstelsel",
      "txt_measurement_system_description": "Selecteer het standaard maatstelsel dat wordt gebruikt in myRotra",
      "txt_metric": "Metrisch",
      "txt_imperial": "Imperiaal"
    }
  },
  "api": {
    "txt_api_documentation": "API Documentatie",
    "txt_integrate_all_realtime_shipment_information": "Integreer alle real-time zendingsinformatie in je eigen ERP-systeem",
    "txt_work_from_one_system": "Werken vanuit één systeem",
    "txt_real_time_status_information_available": "Real-time statusinformatie beschikbaar voor alle collega's en afdelingen",
    "txt_online_convenience_for_greater_efficiency": "Online gemak voor meer efficiëntie en tijdsbesparing",
    "cta_view_documentation": "Bekijk documentatie"
  },
  "profile_menu": {
    "txt_light_mode": "Lichte modus",
    "txt_dark_mode": "Donkere modus",
    "txt_auto_system_default": "Auto (systeemstandaard)",
    "txt_settings": "Instellingen",
    "txt_theme": "Thema",
    "txt_logout": "Uitloggen"
  },
  "single_sales_channel": {
    "lbl_general": "Algemeen",
    "lbl_cargo": "Vracht",
    "lbl_shipper_and_consignee": "Verlader & Ontvanger",
    "lbl_finalize": "Afronden",
    "lbl_finalize_and_submit": "Afronden & Verzenden",
    "txt_general_charges": "Algemene kosten",
    "txt_total": "Totaal",
    "lbl_use_edit_button_to_complete_this_cargo": "Gebruik de bewerkknop rechts om deze vracht te voltooien",
    "txt_booking_in_progress_would_you_like_resume_it": "Je hebt een boeking in behandeling. Wil je deze hervatten?",
    "cta_no_start_new": "Nee, opnieuw starten",
    "cta_yes_resume": "Ja, hervatten",
    "txt_that_our_bad": "Oeps, dat is onze fout",
    "txt_something_went_wrong": "We weten niet precies wat er misging, maar er is iets fout gegaan. Heb je direct hulp nodig? Neem contact op via de 'Support'-knop linksonder.",
    "txt_loading_text_one": "Zoeken naar de beste routes door lucht en land...",
    "txt_loading_text_two": "Even geduld, we zijn er bijna! 🌐🚗🛫",
    "cta_continue_without_rate": "Doorgaan zonder tarief",
    "txt_continue_without_rate": "Doorgaan zonder tarief",
    "txt_continue_without_rate_for_ocean_freight": "Doorgaan zonder tarief voor zeevracht",
    "txt_or": "of",
    "txt_request_a_quote": "Offerte aanvragen",
    "lbl_you_are_about_to_continue_this_booking_without_a_rate": "Je staat op het punt deze boeking voort te zetten zonder tarief. Weet je zeker dat je wilt doorgaan?",
    "alert_continue_without_rate": "<strong>Waarschuwing:</strong> Je staat op het punt deze boeking voort te zetten zonder tarief. Deze functionaliteit is alleen beschikbaar voor zeevracht.",
    "lbl_i_want_to_continue_without_a_rate": "Ik bevestig dat ik wil doorgaan zonder tarief",
    "lbl_i_want_to_continue_without_a_rate_for_ocean_freight": "Ik bevestig dat ik wil doorgaan zonder tarief voor zeevracht",
    "cta_submit_booking": "Boeking verzenden",
    "cta_reset": "Resetten",
    "txt_reset_all_fields": "Weet je zeker dat je alle velden wilt resetten?",
    "txt_booking_has_not_been_submitted_yet": "Je boeking is nog niet verzonden. Wil je doorgaan?",
    "cta_dismiss": "Sluiten",
    "txt_we_filled_in_most_cargo_fields_based_on_your_quote": "We hebben de meeste vrachtvelden ingevuld op basis van je offerte. Vul de vracht hieronder aan om verder te gaan met je boeking.",
    "txt_please_note_that_modifying_cargo": "Let op: het wijzigen van de vracht kan leiden tot een prijsaanpassing.",
    "cta_add_container": "Container toevoegen",
    "cta_add_cargo": "Vracht toevoegen",
    "txt_select_organization_to_book_with": "Selecteer de organisatie waarmee je wilt boeken.",
    "txt_results_will_reflect_its_agreement_with_rotra": "De resultaten zijn gebaseerd op de overeenkomst met Rotra.",
    "txt_changing_the_organization_will_reset_all_fields": "Het wijzigen van de organisatie reset alle velden.",
    "lbl_origin": "Herkomst *",
    "txt_where_will_your_cargo_depart_from": "Vanwaar vertrekt je vracht?",
    "txt_pickup_address_may_be_added_in_a_later_step": "Ophaaladres kan later worden toegevoegd",
    "lbl_destination": "Bestemming *",
    "txt_where_will_your_cargo_arrive": "Waar komt je vracht aan?",
    "txt_delivery_address_may_be_added_in_a_later_step": "Afleveradres kan later worden toegevoegd",
    "txt_avilable_options": "Beschikbare opties",
    "txt_based_on_the_selected_routing_and_incoterm": "Op basis van de geselecteerde route en incoterm hebben we de volgende opties gevonden",
    "txt_expires_in": "Optie verloopt over {{days}} dag(en)",
    "alert_there_are_no_options_that_match_your_search": "Er zijn geen opties die overeenkomen met je zoekopdracht",
    "alert_try_changing_your_input_to_see_results_or_request_a_new_quote": "Probeer je invoer te wijzigen om resultaten te zien of vraag een nieuwe offerte aan",
    "txt_any": "Alle",
    "lbl_transit": "Transittijd",
    "txt_edit_cargo_details": "Vrachtdetails bewerken",
    "txt_please_provide_cargo_details": "Vul de vrachtdetails in",
    "cta_update_cargo": "Vracht bijwerken",
    "alert_some_fields_are_pre_filled": "Sommige velden zijn vooraf ingevuld op basis van je {{entity}}. Vul de overige vrachtdetails hieronder aan om verder te gaan.",
    "alert_quote": "offerte",
    "alert_copied_container": "gekopieerde container",
    "txt_general_information": "Algemene informatie",
    "lbl_goods_description": "Omschrijving goederen *",
    "lbl_select_container_type": "Selecteer containertype",
    "lbl_container_number": "Containernummer",
    "lbl_product_ready_date": "Productgereedheidsdatum",
    "lbl_weight_calculation_method": "Methode gewichtsberekening",
    "lbl_per_piece": "Per stuk",
    "lbl_total": "Totaal",
    "alert_please_note_that_modifying_cargo": "Let op: het wijzigen van de vracht kan leiden tot een prijsaanpassing.",
    "txt_additional_information": "Aanvullende informatie",
    "lbl_hs_code": "HS-code",
    "txt_hs_code_helper": "Gebruik alleen cijfers",
    "lbl_remarks": "Opmerkingen",
    "txt_is_there_anything_that_we_forgot": "Is er iets dat we vergeten zijn dat nuttig kan zijn? Laat het ons weten in dit veld.",
    "lbl_weight_pc": "Gewicht/st.",
    "lbl_total_weight": "Totaalgewicht",
    "lbl_volume_pc": "Volume/st.",
    "lbl_dangerous_goods": "Gevaarlijke goederen",
    "cta_add_package": "Pakket toevoegen",
    "lbl_length_pc": "Lengte/st.",
    "lbl_width_pc": "Breedte/st.",
    "lbl_height_pc": "Hoogte/st.",
    "lbl_total_volume": "Totaal volume: {{volume}}",
    "lbl_cannot_find_what_you_need": "Kun je niet vinden wat je zoekt?",
    "txt_request_a_quote_to_receive_a_personalized_offer": "Vraag een offerte aan voor een persoonlijk aanbod.",
    "txt_information_from_this_form_will_be_copied_to_the_quote_request_form": "De informatie uit dit formulier wordt gekopieerd naar het offerteformulier.",
    "alert_creating_booking_from_existing": "Je maakt een boeking aan op basis van een bestaande {{entity}}",
    "txt_contract": "Contract",
    "txt_quote": "Offerte",
    "cta_change_option": "Optie wijzigen",
    "txt_we_filled_in_some_information_based_on_your": "We hebben enkele gegevens ingevuld op basis van je {{entity}}. Vooraf ingevulde informatie is gemarkeerd met een",
    "txt_icon": " pictogram.",
    "txt_try_changing_your_input_to_see_results_or_request_a_new_quote": "Probeer je invoer te wijzigen om resultaten te zien of vraag een nieuwe offerte aan",
    "txt_no_description": "Geen omschrijving",
    "txt_what_do_you_want_ship": "Wat wil je verzenden?",
    "lbl_shipper": "Verlader",
    "lbl_consignee": "Ontvanger",
    "lbl_pickup_address": "Ophaaladres",
    "lbl_delivery_address": "Afleveradres",
    "lbl_service_property_is_the_same_as_entity_address": "{{service}} is hetzelfde als het adres van {{entity}}",
    "txt_choose": "Kies {{label}}",
    "txt_optional_select": "Optioneel: selecteer {{label}}",
    "lbl_quick_select": "Snelkeuze:",
    "txt_shipper_and_consignee": "Verlader & Ontvanger",
    "txt_provide_the_shipping_and_consignee_for_your_cargo": "Vul de verlader en ontvanger van je vracht in",
    "txt_terms_and_conditions": "Voorwaarden",
    "txt_thank_you_for_placing_a_booking_request_with_us": "Bedankt voor je boekingsaanvraag! Zodra je boeking is bevestigd door onze operatieafdeling, volgen de verzenddetails.",
    "txt_finalize": "Afronden",
    "txt_please_enter_your_booking_reference": "Vul je boekingsreferentie in en controleer de onderstaande gegevens.",
    "alert_please_note": "Let op:",
    "alert_different_rate_may_be_applicable": "Een ander tarief kan van toepassing zijn op basis van de Shipped on Board (B/L)-datum van je zending.",
    "lbl_reference_for_this_booking": "Referentie voor deze boeking",
    "ph_for_example": "Bijv.: PO:00001",
    "txt_booking_reference": "Boekingsreferentie",
    "txt_purchase_references_helper": "Scheid meerdere referenties met een komma, spatie of enter",
    "txt_purchase_reference_already_added": "'{{reference}}' is al toegevoegd",
    "alert_different_cotnract_rate_may_be_applicable": "Een ander contract/tarief kan van toepassing zijn op basis van de Shipped on Board (B/L)-datum van je zending",
    "txt_quote_for": "Offerte voor {{client_name}}: {{allInPrice}}",
    "txt_we_have_copied_attachments_for_you": "We hebben {{amount}} {{attachments}} voor je gekopieerd",
    "txt_the_following_attachmetns_will_be_copied_from_your_request": "De volgende bijlagen worden van je aanvraag naar de boeking gekopieerd",
    "txt_click_here_to_select_doucments": "Klik hier om documenten te selecteren",
    "txt_or_drag_file_here_to_upload": "of sleep een bestand hierheen om te uploaden",
    "lbl_maximum_upload_file_size": "Maximale bestandsgrootte: 10MB",
    "lbl_i_accept_the": "Ik accepteer de",
    "lbl_forwarders_conditions": "expediteursvoorwaarden",
    "lbl_and_the": "en de",
    "lbl_general_conditions": "algemene voorwaarden",
    "lbl_on_behalf_of": "namens {{client_name}}",
    "lbl_you_must_accept_the_conditions_before_submitting": "Je moet de voorwaarden accepteren voordat je deze boeking kunt verzenden.",
    "txt_booking_organization": "Boekingsorganisatie",
    "txt_you_need_to_accept_the_conditions": "Je moet de voorwaarden accepteren.",
    "txt_per_piece": "per stuk",
    "lbl_container_type": "Containertype",
    "txt_client_reference_has_a_maximum_of_35_characters": "Klantreferentie mag maximaal 35 tekens bevatten",
    "txt_you_must_accept_the_terms_and_conditions": "U moet de algemene voorwaarden accepteren",
    "txt_option": "optie",
    "txt_options": "opties",
    "txt_pc": "st.",
    "txt_product_ready_date_cannot_be_more_than_1_year_in_the_past": "De productgereedheidsdatum mag niet meer dan 1 jaar in het verleden liggen",
    "txt_product_ready_date_cannot_be_more_than_5_years_in_the_future": "De productgereedheidsdatum mag niet meer dan 5 jaar in de toekomst liggen",
    "txt_product_ready_date_must_be_within_1_year_in_the_past_and_5_years_in_the_future": "De productgereedheidsdatum moet binnen 1 jaar in het verleden en 5 jaar in de toekomst liggen",
    "txt_please_use_a_valid_date_in_format": "Gebruik een geldige datum in het formaat dd-mm-yyyy",
    "cta_view_details": "Details bekijken",
    "cta_add_more_details": "+ Meer details toevoegen",
    "txt_incoterm_colon": "Incoterm:",
    "txt_no_cargo_added_yet": "Nog geen vracht toegevoegd",
    "txt_no_price_yet": "Nog geen prijs",
    "txt_no_carrier_found": "Geen vervoerder gevonden",
    "txt_containers": "containers",
    "txt_container": "container",
    "txt_cargo": "Vracht",
    "txt_transit_time": "Transittijd",
    "txt_no_carrier_specific": "Geen specifieke vervoerder",
    "txt_cargo_information_will_be_added": "Vrachtgegevens worden in de volgende stap toegevoegd",
    "alert_provide_additional_information": "Geef aanvullende informatie op"
  },
  "address_fields": {
    "lbl_name": "Naam",
    "lbl_street_address_1": "Straat en huisnummer 1",
    "lbl_street_address_2": "Straat en huisnummer 2",
    "lbl_country": "Land",
    "lbl_postal_code": "Postcode",
    "lbl_city": "Plaats",
    "lbl_email": "E-mail",
    "lbl_phone": "Telefoon",
    "txt_no_addresses_found": "Geen adressen gevonden",
    "txt_search_contacts": "Zoek contactpersonen",
    "txt_company": "BEDRIJF",
    "txt_company_edited": "bedrijf bewerkt",
    "txt_from_addressbook": "uit adresboek",
    "txt_no_companies_found": "Geen bedrijven gevonden",
    "txt_contact": "CONTACT",
    "cta_add_new": "Nieuw toevoegen",
    "txt_contact_edited": "contact bewerkt",
    "txt_new_contact": "nieuw contact",
    "lbl_cotnact_without_name_and_email": "Contact zonder naam en e-mail",
    "txt_no_contacts_found": "Geen contactpersonen gevonden",
    "txt_country_field_needs_update": "Het landveld in dit adres moet worden bijgewerkt. Kies een land uit de lijst.",
    "txt_loading_address_book": "Adresboek wordt geladen",
    "lbl_netherlands": "Nederland",
    "lbl_belgium": "België",
    "lbl_germany": "Duitsland"
  },
  "cargo": {
    "lbl_weight_calculation_method": "Methode voor gewichtsberekening",
    "txt_weight_per_piece": "Gewicht per stuk *",
    "txt_total_weight": "Totaal gewicht *",
    "txt_length_per_piece": "Lengte per stuk *",
    "txt_width_per_piece": "Breedte per stuk *",
    "txt_height_per_piece": "Hoogte per stuk *",
    "txt_volume_per_piece": "Volume {{data}}",
    "txt_per_piece": " per stuk",
    "txt_dangerous_goods": "Gevaarlijke goederen",
    "txt_total": "totaal",
    "cta_add_package": "Pakket toevoegen",
    "txt_goods_description": "Goederenomschrijving *",
    "txt_remarks": "Opmerkingen",
    "txt_product_ready_date": "Datum waarop de goederen gereed zijn"
  },
  "booking_details": {
    "txt_air_freight": "Luchtvracht",
    "txt_ocean_freight": "Zeevracht",
    "txt_you_have_requested_this_booking_on": "U heeft deze boeking aangevraagd op {{date}}.",
    "txt_your_shipment_is_available": "Uw zending is beschikbaar:",
    "lbl_origin": "Herkomst",
    "lbl_destination": "Bestemming",
    "lbl_shipper": "Verlader",
    "txt_weight_per_piece": "Gewicht per stuk",
    "txt_total_weight": "Totaalgewicht",
    "txt_dimensions_per_piece": "Dimensies per stuk",
    "txt_volume_per_piece": "Volume per stuk",
    "txt_dangerous_goods": "Gevaarlijke goederen",
    "txt_no": "Nee",
    "txt_additional_information": "Aanvullende informatie",
    "txt_consignee": "Ontvanger",
    "txt_new_booking_cargo": "Nieuwe boeking: Lading",
    "cta_delete_container": "Container verwijderen",
    "cta_add_another_container": "Nog een container toevoegen",
    "txt_shipper_and_cargo_details": "Details van verlader & lading",
    "lbl_quick_select": "Snel selecteren:",
    "txt_no_contact_person": "Geen contactpersoon",
    "txt_per_piece": "per stuk",
    "cta_delete_package": "Pakket verwijderen",
    "cta_add_another_package": "Nog een pakket toevoegen",
    "ph_briefly_describe_your_shipment": "Geef een korte beschrijving van de inhoud van uw zending",
    "lbl_additional_information": "Aanvullende informatie",
    "ph_entry_any_additional_information": "Voer alle extra informatie in die nuttig kan zijn",
    "cta_delete_shipper": "Verlader verwijderen",
    "cta_add_another_shipper": "Nog een verlader toevoegen",
    "txt_pc": "st."
  },
  "rotra_select": {
    "txt_select_an_option": "Selecteer een optie",
    "txt_disabled_because_the_form_is_read_only": "Uitgeschakeld omdat het formulier alleen-lezen is",
    "txt_quick_select": "Snel selecteren"
  },
  "booking_step_general": {
    "txt_new_booking_general": "Nieuwe boeking: Algemeen",
    "txt_general_information": "Algemene informatie",
    "alert_change_the_organization": "Als u de <strong>organisatie</strong> wijzigt, worden de geselecteerde verlader- en ontvangeradressen, evenals eventuele geüploade bijlagen, opnieuw ingesteld.",
    "txt_active_organizations": "Actieve organisaties",
    "txt_obsolete_organizations": "Verouderde organisaties",
    "lbl_origin": "Herkomst",
    "lbl_destination": "Bestemming",
    "txt_only_file_names_without_special_characters": "Alleen bestandsnamen zonder speciale tekens (Voorbeelden: example.pdf, example101.pdf en example_101.pdf) worden ondersteund door myRotra.\nWijzig de bestandsnaam van uw upload om verder te gaan met uw boeking."
  },
  "booking_step": {
    "txt_new_booking": "Nieuwe boeking",
    "lbl_i_accept_the_description": "Ik accepteer de {{description}}",
    "cta_download": "Downloaden",
    "cta_previous": "Vorige",
    "txt_loading": "Laden",
    "txt_sending_booking": "Boeking wordt verzonden...",
    "cta_submit_booking": "Boeking verzenden"
  },
  "booking_step_consignee": {
    "lbl_consignee": "Ontvanger",
    "txt_new_booking_consignee": "Nieuwe boeking: Ontvanger",
    "lbl_quick_select": "Snel selecteren:",
    "txt_no_contact_person": "Geen contactpersoon"
  },
  "booking_step_review": {
    "txt_new_booking_review": "Nieuwe boeking: Controle",
    "txt_almost_here": "Bijna klaar...",
    "txt_please_verify_your_booking_information_below": "Controleer hieronder uw boekingsinformatie. Klik op een van de bewerkknoppen als u iets moet corrigeren, of gebruik de verzendknop bovenaan of onderaan deze pagina om uw boeking in te dienen.",
    "lbl_accept_the_description": "Ik accepteer de {{description}}",
    "txt_loading": "Laden",
    "txt_sending_booking": "Boeking wordt verzonden...",
    "cta_submit_booking": "Boeking verzenden"
  },
  "booking_page": {
    "txt_thank_you_for_placing_booking": "Bedankt dat u een boekingsaanvraag bij ons heeft geplaatst! De verzenddetails volgen zodra uw boeking is bevestigd door onze operatieafdeling.",
    "txt_transport_unknown": "Transport onbekend",
    "cta_quote_booking": "Offerteboeking",
    "txt_default_booking": "Standaardboeking",
    "txt_would_you_like_to_resume_your_booking": "Wilt u uw boeking hervatten waar u was gebleven?",
    "cta_no_start_new": "Nee, nieuw starten",
    "cta_yes_resume": "Ja, hervatten",
    "txt_new_booking": "Nieuwe boeking",
    "txt_we_have_completed_most_fields": "We hebben de meeste velden voor u ingevuld op basis van uw offerte.",
    "txt_please_verify_that_everything_is_as_expected": "Controleer of alles naar verwachting is en vul de velden in de gemarkeerde blokken aan waar nodig.",
    "txt_information_left_for_you_to_complete": "Informatie die u nog moet invullen: uw referentie (optioneel), bijlagen (optioneel), lading- en verladerinformatie (vereist), ontvangerinformatie (vereist)."
  },
  "non_conformities": {
    "txt_click_to_view_non_conformities": "Klik om non-conformities te bekijken",
    "cta_submit_report": "Rapport indienen",
    "txt_all_non_conformities_related_to_this_shipment_are_listed_below": "Alle niet-conformiteiten met betrekking tot deze zending staan hieronder vermeld. Controleer de details van elk rapport om de voortgang en status te volgen.",
    "txt_document_and_track_quality_issues_related_to_this_shipment": "Documenteer en volg kwaliteitsproblemen met betrekking tot deze zending. Selecteer het type probleem en geef een duidelijke omschrijving, zodat we snel de juiste actie kunnen ondernemen.",
    "txt_view_detailed_information_about_this_non_conformity": "Bekijk gedetailleerde informatie over deze niet-conformiteit, inclusief de status, beschrijving en eventuele genomen acties. Gebruik de terugknop om terug te keren naar de lijst met non-conformities.",
    "txt_report_non_conformity": "Niet-conformiteit melden",
    "txt_non_conformities_amount": "Niet-conformiteiten ({{amount}})",
    "txt_basic_information": "Basisinformatie",
    "txt_date": "Datum",
    "txt_non_conformity_type": "Type niet-conformiteit",
    "txt_sales_or_quote": "Sales of Offerte",
    "txt_delay": "Vertraging(en)",
    "txt_damage_missing": "Schade/Vermissing",
    "txt_financial": "Financieel",
    "txt_operational": "Operationeel",
    "txt_details": "Details",
    "lbl_description": "Beschrijving",
    "ph_enter_description_here": "Voer hier een beschrijving in...",
    "lbl_non_conformity_date": "Datum van niet-conformiteit",
    "lbl_type": "Type",
    "lbl_filed_by": "Ingediend door",
    "txt_by_on_date": "{{name}} op {{date}}",
    "lbl_action": "Actie",
    "txt_handled_by_on": "Afgehandeld door {{name}} op {{date}}",
    "alert_no_action_has_been_taken_yet": "Er is nog geen actie ondernomen.",
    "cta_file_non_conformity": "Niet-conformiteit indienen",
    "txt_no_non_conformity_reports_found": "Geen niet-conformiteitsrapporten gevonden.",
    "txt_filed_by_on": "Ingediend door: {{name}} op {{date}}",
    "lbl_status_open": "Open",
    "lbl_status_in_progress": "In behandeling",
    "lbl_status_resolved": "Opgelost",
    "lbl_status_default": "Onbekende status",
    "lbl_damage_missing": "Schade / Vermissing",
    "lbl_delay": "Vertraging(en)",
    "type_financial": "Financieel",
    "lbl_sales_quote": "Sales / Offerte",
    "lbl_operational": "Operationeel",
    "lbl_default": "Onbekend type",
    "txt_non_conformity_reprot_has_been_submitted": "Het niet-conformiteitsrapport is ingediend"
  },
  "intro_user": {
    "txt_welcome_to_myrotra": "Welkom bij myRotra",
    "txt_you_have_successfully_created_your_account": "Je account is succesvol aangemaakt",
    "cta_track_your_shipments": "Volg je zendingen",
    "cta_go_directly_to_your_shipments": "Ga direct naar je zendingen en begin met volgen via myRotra",
    "cta_go_to_dashboard": "Ga naar het dashboard",
    "txt_how_would_you_like_to_proceed": "Hoe wil je verder gaan?",
    "cta_request_your_first_quote": "Vraag je eerste offerte aan",
    "txt_congratulations": "Gefeliciteerd!"
  },
  "error_user": {
    "txt_something_went_wrong": "Er is iets misgegaan",
    "txt_something_went_wrong_error_text": "Er is iets misgegaan...",
    "cta_go_to_main_page": "Ga naar de hoofdpagina",
    "txt_unexpected_error_occurred_while_attemppting_to_perform_requested_operation": "Er heeft zich een onverwachte fout voorgedaan tijdens het uitvoeren van de gevraagde handeling. Onze excuses voor het ongemak. Probeer het later opnieuw of neem contact met ons op via de supporttool."
  },
  "authenticated_user": {
    "txt_already_logged_in": "Al ingelogd...",
    "cta_continue_to_myrotra": "Ga verder naar myRotra",
    "cta_sign_out": "Uitloggen",
    "txt_you_are_already_signed_in": "Je bent al ingelogd",
    "txt_you_cannot_sing_up_while_logged_in": "Je kunt je niet opnieuw registreren terwijl je bent ingelogd. Als je een nieuw account wilt aanmaken, moet je eerst uitloggen. Je kunt ook gewoon myRotra blijven gebruiken."
  },
  "submitting_user": {
    "txt_activating_account": "Account activeren",
    "txt_signing_you_in": "Je wordt aangemeld",
    "txt_something_went_wrong": "Er is iets misgegaan",
    "txt_something_went_wrong_error_text": "Er is iets misgegaan...",
    "cta_go_to_main_page": "Ga naar de hoofdpagina",
    "txt_something_unexpected_happend_while_activation_your_account": "Er is iets onverwachts misgegaan tijdens het activeren van je account. Onze excuses voor het ongemak. Probeer het later opnieuw of neem contact met ons op via de supporttool.",
    "txt_an_unexpected_error_occurred_while_signing_you_in": "Er heeft zich een onverwachte fout voorgedaan tijdens het aanmelden. Ga verder naar de inlogpagina om myRotra te blijven gebruiken."
  },
  "activate_user": {
    "cta_complete": "Voltooien",
    "txt_welcome_to_myrotra": "Welkom bij myRotra!",
    "txt_just_few_simple_steps": "We zijn blij dat je er bent! In slechts een paar eenvoudige stappen ben je helemaal klaar om te beginnen met een geweldige ervaring. Laten we gaan!",
    "txt_continue_to_the_next_step_to_get_started": "Ga door naar de volgende stap om te beginnen en maak een account aan voor:",
    "txt_already_have_an_account": "Heb je al een account?",
    "cta_sign_in_here": "Log hier in",
    "txt_who_are_you": "Wie ben jij?",
    "txt_please_tell_us_about_yourself": "Vertel ons iets over jezelf zodat we je ervaring kunnen afstemmen. Dit helpt ons om de best mogelijke service te bieden.",
    "ph_first_name": "Voornaam",
    "lbl_first_name": "Voornaam",
    "ph_last_name": "Achternaam",
    "lbl_last_name": "Achternaam",
    "txt_secure_your_account": "Beveilig je account",
    "txt_protect_your_account_by_creating_a_strong_and_secure_password": "Beveilig je account door een sterk en veilig wachtwoord aan te maken. Dit houdt je gegevens veilig en zorgt ervoor dat alleen jij toegang hebt.",
    "lbl_password": "Wachtwoord",
    "txt_password_requirements": "Je wachtwoord moet bevatten:",
    "txt_terms_of_use": "Gebruiksvoorwaarden",
    "lbl_i_agree_to_the_terms_of_use": "Ik ga akkoord met de Gebruiksvoorwaarden",
    "lbl_at_least_8_characters": "Minstens 8 tekens",
    "lbl_at_least_one_lower_and_uppercase": "Minstens één kleine en één hoofdletter",
    "lbl_at_least_one_number": "Minstens één cijfer",
    "lbl_at_least_one_special_character": "Minstens één speciaal teken (!@#$%^&*)"
  },
  "calendar": {
    "txt_calendar": "Kalender",
    "txt_purchase_references": "Aankoopreferenties",
    "txt_you_have_no_upcoming_activities": "Je hebt geen aankomende activiteiten",
    "txt_later": "later",
    "txt_earlier": "eerder"
  },
  "navigation_guide": {
    "txt_finish_tour": "Rond de rondleiding af",
    "txt_skip_tour": "Sla de rondleiding over",
    "txt_address_book_step_1": "Het adresboek wordt gebruikt om je contacten op te slaan, gegroepeerd per bedrijf. Het adresboek wordt automatisch gevuld wanneer je verzender- en ontvangergegevens invoert tijdens het boekingsproces van myRotra.",
    "txt_address_book_step_2": "Je kunt zoeken op bedrijfsnaam en contactpersoon.",
    "txt_address_book_step_3": "Je kunt het adresboek ook handmatig vooraf vullen met contacten als je weet dat je bepaalde contacten vaak wilt hergebruiken tijdens het boekingsproces.",
    "txt_bookings_step_1": "Deze pagina toont je het overzicht van boekingen.",
    "txt_bookings_step_2": "Je kunt boekingen zoeken met behulp van trefwoorden.",
    "txt_bookings_step_3": "Je kunt filteren op lucht-/zeevracht en status.",
    "txt_bookings_step_4": "Via deze knop kun je nieuwe boekingen toevoegen.",
    "txt_booking_widget_step_1": "Welkom bij de Boeking-widget. Deze widget helpt je bij het indienen van een boeking vanuit een contract.",
    "txt_booking_widget_step_2": "Dit gedeelte van de Boeking-widget toont je voortgang en de vereiste stappen om een boeking in te dienen.",
    "txt_booking_widget_step_3": "Dit gedeelte van de Boeking-widget toont je voortgang en de vereiste stappen om een boeking in te dienen.",
    "txt_booking_widget_step_4": "Dit gedeelte van de Boeking-widget helpt je bij het navigeren naar de volgende of vorige stap.",
    "txt_booking_widget_step_5": "Je kunt naar de volgende pagina gaan zodra de verplichte velden zijn ingevuld.",
    "txt_contracts_step_1": "Deze pagina toont een overzicht van je contracten.",
    "txt_contracts_step_2": "Je kunt contracten filteren op status.",
    "txt_contracts_step_3": "Dit is een samenvatting van je contract. Deze samenvatting toont details zoals de modaliteit, jouw referentie, de incoterm, de route en de vervaldatum.",
    "txt_contracts_step_4": "Je kunt een contract boeken door op de boekingsknop te klikken.",
    "txt_navigation_step_1": "Welkom bij myRotra! Klik op \"volgende\" voor een korte rondleiding door het systeem, of klik op \"overslaan\" als je direct wilt beginnen.",
    "txt_navigation_step_2": "Systeemberichten verschijnen hier. Ze informeren je over gebeurtenissen met betrekking tot boekingen en zendingen. Wanneer we een nieuwe versie uitbrengen, ontvang je ook een melding met een overzicht van de wijzigingen.",
    "txt_navigation_step_3": "Navigatie die betrekking heeft op je gebruikersprofiel open je door op de avatar te klikken, bijvoorbeeld om je wachtwoord te wijzigen of uit te loggen.",
    "txt_navigation_step_4": "De hoofdnavigatie bevat alle beschikbare functionaliteit van myRotra. Wanneer je een pagina voor het eerst bezoekt, krijg je een pagina-specifieke rondleiding.",
    "txt_shipments_step_1": "Deze pagina toont je het overzicht van zendingen.",
    "txt_shipments_step_2": "Je kunt zendingen zoeken met behulp van trefwoorden.",
    "txt_shipments_step_3": "Je kunt filteren op lucht-/zeevracht, import/export, status en je kunt de sorteervolgorde aanpassen."
  }
}
